/**
 * Generated by orval v7.1.1 🍺
 * Do not edit manually.
 * Hosting UAPI
 * Hosting UAPI is an API to expose Hosting, Addons, and Site functionality to a customer-facing Front End such as (Account Manager).
 * OpenAPI spec version: 1.1398.0
 */
import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';
import axios from 'axios';
/**
 * Returns a list of events across a tenant
 * @summary Event list for all accounts under a tenant
 */
export const accountEventList = (params, options) => {
    return axios.get(`/v1/account/events`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getAccountEventListQueryKey = (params) => {
    return [`/v1/account/events`, ...(params ? [params] : [])];
};
export const getAccountEventListQueryOptions = (params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getAccountEventListQueryKey(params);
    const queryFn = ({ signal }) => accountEventList(params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn }, queryOptions);
};
/**
 * @summary Event list for all accounts under a tenant
 */
export function useAccountEventList(params, options) {
    const queryOptions = getAccountEventListQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns a hosting account list
 * @summary Hosting account list for a customer
 */
export const accountHostingList = (options) => {
    return axios.get(`/v1/account/hosting`, options);
};
export const getAccountHostingListQueryKey = () => {
    return [`/v1/account/hosting`];
};
export const getAccountHostingListQueryOptions = (options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getAccountHostingListQueryKey();
    const queryFn = ({ signal }) => accountHostingList(Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn }, queryOptions);
};
/**
 * @summary Hosting account list for a customer
 */
export function useAccountHostingList(options) {
    const queryOptions = getAccountHostingListQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns the account public key list
 * @summary Account public key list
 */
export const accountPublicKeys = (options) => {
    return axios.get(`/v1/account/public-keys`, options);
};
export const getAccountPublicKeysQueryKey = () => {
    return [`/v1/account/public-keys`];
};
export const getAccountPublicKeysQueryOptions = (options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getAccountPublicKeysQueryKey();
    const queryFn = ({ signal }) => accountPublicKeys(Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn }, queryOptions);
};
/**
 * @summary Account public key list
 */
export function useAccountPublicKeys(options) {
    const queryOptions = getAccountPublicKeysQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Create an account public key
 * @summary Account public key creation
 */
export const accountPublicKeyCreate = (accountPublicKeyCreateBody, options) => {
    return axios.post(`/v1/account/public-keys`, accountPublicKeyCreateBody, options);
};
export const getAccountPublicKeyCreateMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { data } = props !== null && props !== void 0 ? props : {};
        return accountPublicKeyCreate(data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Account public key creation
*/
export const useAccountPublicKeyCreate = (options) => {
    const mutationOptions = getAccountPublicKeyCreateMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns an account public key
 * @summary Account public key info
 */
export const accountPublicKey = (publicKeyId, options) => {
    return axios.get(`/v1/account/public-keys/${publicKeyId}`, options);
};
export const getAccountPublicKeyQueryKey = (publicKeyId) => {
    return [`/v1/account/public-keys/${publicKeyId}`];
};
export const getAccountPublicKeyQueryOptions = (publicKeyId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getAccountPublicKeyQueryKey(publicKeyId);
    const queryFn = ({ signal }) => accountPublicKey(publicKeyId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(publicKeyId) }, queryOptions);
};
/**
 * @summary Account public key info
 */
export function useAccountPublicKey(publicKeyId, options) {
    const queryOptions = getAccountPublicKeyQueryOptions(publicKeyId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Enable or disable a pubkey on an account.
 * @summary Account public key toggle
 */
export const accountPublicKeyToggle = (publicKeyId, accountPublicKeyToggleBody, options) => {
    return axios.post(`/v1/account/public-keys/${publicKeyId}`, accountPublicKeyToggleBody, options);
};
export const getAccountPublicKeyToggleMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { publicKeyId, data } = props !== null && props !== void 0 ? props : {};
        return accountPublicKeyToggle(publicKeyId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Account public key toggle
*/
export const useAccountPublicKeyToggle = (options) => {
    const mutationOptions = getAccountPublicKeyToggleMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Delete an account public key
 * @summary Account public key deletion
 */
export const accountPublicKeyDelete = (publicKeyId, options) => {
    return axios.delete(`/v1/account/public-keys/${publicKeyId}`, options);
};
export const getAccountPublicKeyDeleteMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { publicKeyId } = props !== null && props !== void 0 ? props : {};
        return accountPublicKeyDelete(publicKeyId, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Account public key deletion
*/
export const useAccountPublicKeyDelete = (options) => {
    const mutationOptions = getAccountPublicKeyDeleteMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns a combined backup list with website commit ids and corresponding database commits
 * @summary backup list
 */
export const codeguardBackupList = (addonId, params, options) => {
    return axios.get(`/v1/addons/codeguard/${addonId}/backups`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getCodeguardBackupListQueryKey = (addonId, params) => {
    return [`/v1/addons/codeguard/${addonId}/backups`, ...(params ? [params] : [])];
};
export const getCodeguardBackupListQueryOptions = (addonId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getCodeguardBackupListQueryKey(addonId, params);
    const queryFn = ({ signal }) => codeguardBackupList(addonId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(addonId) }, queryOptions);
};
/**
 * @summary backup list
 */
export function useCodeguardBackupList(addonId, params, options) {
    const queryOptions = getCodeguardBackupListQueryOptions(addonId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Creates the website backup
 * @summary backup create
 */
export const codeguardBackupCreate = (addonId, codeguardBackupCreateBody, options) => {
    return axios.post(`/v1/addons/codeguard/${addonId}/backups`, codeguardBackupCreateBody, options);
};
export const getCodeguardBackupCreateMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { addonId, data } = props !== null && props !== void 0 ? props : {};
        return codeguardBackupCreate(addonId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary backup create
*/
export const useCodeguardBackupCreate = (options) => {
    const mutationOptions = getCodeguardBackupCreateMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Queues the backup download.
 * @summary backup download
 */
export const codeguardBackupDownload = (addonId, codeguardBackupDownloadBody, options) => {
    return axios.post(`/v1/addons/codeguard/${addonId}/backups/download`, codeguardBackupDownloadBody, options);
};
export const getCodeguardBackupDownloadMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { addonId, data } = props !== null && props !== void 0 ? props : {};
        return codeguardBackupDownload(addonId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary backup download
*/
export const useCodeguardBackupDownload = (options) => {
    const mutationOptions = getCodeguardBackupDownloadMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Restores a website and database backup
 * @summary backups restore
 */
export const codeguardBackupRestore = (addonId, codeguardBackupRestoreBody, options) => {
    return axios.post(`/v1/addons/codeguard/${addonId}/backups/restore`, codeguardBackupRestoreBody, options);
};
export const getCodeguardBackupRestoreMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { addonId, data } = props !== null && props !== void 0 ? props : {};
        return codeguardBackupRestore(addonId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary backups restore
*/
export const useCodeguardBackupRestore = (options) => {
    const mutationOptions = getCodeguardBackupRestoreMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns all database records CodeGuard maintains for this user's account.
 * @summary database list
 */
export const codeguardDatabaseList = (addonId, options) => {
    return axios.get(`/v1/addons/codeguard/${addonId}/databases`, options);
};
export const getCodeguardDatabaseListQueryKey = (addonId) => {
    return [`/v1/addons/codeguard/${addonId}/databases`];
};
export const getCodeguardDatabaseListQueryOptions = (addonId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getCodeguardDatabaseListQueryKey(addonId);
    const queryFn = ({ signal }) => codeguardDatabaseList(addonId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(addonId) }, queryOptions);
};
/**
 * @summary database list
 */
export function useCodeguardDatabaseList(addonId, options) {
    const queryOptions = getCodeguardDatabaseListQueryOptions(addonId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns all database backup records CodeGuard maintains for this user's account.
 * @summary database backup list
 */
export const codeguardDatabaseBackupList = (addonId, params, options) => {
    return axios.get(`/v1/addons/codeguard/${addonId}/databases/backups`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getCodeguardDatabaseBackupListQueryKey = (addonId, params) => {
    return [`/v1/addons/codeguard/${addonId}/databases/backups`, ...(params ? [params] : [])];
};
export const getCodeguardDatabaseBackupListQueryOptions = (addonId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getCodeguardDatabaseBackupListQueryKey(addonId, params);
    const queryFn = ({ signal }) => codeguardDatabaseBackupList(addonId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(addonId) }, queryOptions);
};
/**
 * @summary database backup list
 */
export function useCodeguardDatabaseBackupList(addonId, params, options) {
    const queryOptions = getCodeguardDatabaseBackupListQueryOptions(addonId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Queue the creation of a database backup.
 * @summary database backup create
 */
export const codeguardDatabaseBackupCreate = (addonId, codeguardDatabaseBackupCreateBody, options) => {
    return axios.post(`/v1/addons/codeguard/${addonId}/databases/backups`, codeguardDatabaseBackupCreateBody, options);
};
export const getCodeguardDatabaseBackupCreateMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { addonId, data } = props !== null && props !== void 0 ? props : {};
        return codeguardDatabaseBackupCreate(addonId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary database backup create
*/
export const useCodeguardDatabaseBackupCreate = (options) => {
    const mutationOptions = getCodeguardDatabaseBackupCreateMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Restores a database backup
 * @summary  database backup restore
 */
export const codeguardDatabaseBackupRestore = (addonId, codeguardDatabaseBackupRestoreBody, options) => {
    return axios.post(`/v1/addons/codeguard/${addonId}/databases/backups/restore`, codeguardDatabaseBackupRestoreBody, options);
};
export const getCodeguardDatabaseBackupRestoreMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { addonId, data } = props !== null && props !== void 0 ? props : {};
        return codeguardDatabaseBackupRestore(addonId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary  database backup restore
*/
export const useCodeguardDatabaseBackupRestore = (options) => {
    const mutationOptions = getCodeguardDatabaseBackupRestoreMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns an oauth login URL that can be used to access CodeGuard dashboard for a user.
 * @summary login link
 */
export const codeguardLoginLink = (addonId, options) => {
    return axios.get(`/v1/addons/codeguard/${addonId}/login`, options);
};
export const getCodeguardLoginLinkQueryKey = (addonId) => {
    return [`/v1/addons/codeguard/${addonId}/login`];
};
export const getCodeguardLoginLinkQueryOptions = (addonId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getCodeguardLoginLinkQueryKey(addonId);
    const queryFn = ({ signal }) => codeguardLoginLink(addonId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(addonId) }, queryOptions);
};
/**
 * @summary login link
 */
export function useCodeguardLoginLink(addonId, options) {
    const queryOptions = getCodeguardLoginLinkQueryOptions(addonId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns the subscribed plan and usage info
 * @summary plan info
 */
export const codeguardPlanInfo = (addonId, options) => {
    return axios.get(`/v1/addons/codeguard/${addonId}/plan`, options);
};
export const getCodeguardPlanInfoQueryKey = (addonId) => {
    return [`/v1/addons/codeguard/${addonId}/plan`];
};
export const getCodeguardPlanInfoQueryOptions = (addonId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getCodeguardPlanInfoQueryKey(addonId);
    const queryFn = ({ signal }) => codeguardPlanInfo(addonId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(addonId) }, queryOptions);
};
/**
 * @summary plan info
 */
export function useCodeguardPlanInfo(addonId, options) {
    const queryOptions = getCodeguardPlanInfoQueryOptions(addonId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns all website records CodeGuard maintains for this user's account.
 * @summary website list
 */
export const codeguardWebsiteList = (addonId, options) => {
    return axios.get(`/v1/addons/codeguard/${addonId}/websites`, options);
};
export const getCodeguardWebsiteListQueryKey = (addonId) => {
    return [`/v1/addons/codeguard/${addonId}/websites`];
};
export const getCodeguardWebsiteListQueryOptions = (addonId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getCodeguardWebsiteListQueryKey(addonId);
    const queryFn = ({ signal }) => codeguardWebsiteList(addonId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(addonId) }, queryOptions);
};
/**
 * @summary website list
 */
export function useCodeguardWebsiteList(addonId, options) {
    const queryOptions = getCodeguardWebsiteListQueryOptions(addonId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns all website backup records CodeGuard maintains for this user's account.
 * @summary  website backup list
 */
export const codeguardWebsiteBackupList = (addonId, params, options) => {
    return axios.get(`/v1/addons/codeguard/${addonId}/websites/backups`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getCodeguardWebsiteBackupListQueryKey = (addonId, params) => {
    return [`/v1/addons/codeguard/${addonId}/websites/backups`, ...(params ? [params] : [])];
};
export const getCodeguardWebsiteBackupListQueryOptions = (addonId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getCodeguardWebsiteBackupListQueryKey(addonId, params);
    const queryFn = ({ signal }) => codeguardWebsiteBackupList(addonId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(addonId) }, queryOptions);
};
/**
 * @summary  website backup list
 */
export function useCodeguardWebsiteBackupList(addonId, params, options) {
    const queryOptions = getCodeguardWebsiteBackupListQueryOptions(addonId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Initiate the creation of a new backup for a given website
 * @summary website backup create
 */
export const codeguardWebsiteBackupCreate = (addonId, codeguardWebsiteBackupCreateBody, options) => {
    return axios.post(`/v1/addons/codeguard/${addonId}/websites/backups`, codeguardWebsiteBackupCreateBody, options);
};
export const getCodeguardWebsiteBackupCreateMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { addonId, data } = props !== null && props !== void 0 ? props : {};
        return codeguardWebsiteBackupCreate(addonId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary website backup create
*/
export const useCodeguardWebsiteBackupCreate = (options) => {
    const mutationOptions = getCodeguardWebsiteBackupCreateMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Restores a website backup
 * @summary  website backup restore
 */
export const codeguardWebsiteBackupRestore = (addonId, codeguardWebsiteBackupRestoreBody, options) => {
    return axios.post(`/v1/addons/codeguard/${addonId}/websites/backups/restore`, codeguardWebsiteBackupRestoreBody, options);
};
export const getCodeguardWebsiteBackupRestoreMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { addonId, data } = props !== null && props !== void 0 ? props : {};
        return codeguardWebsiteBackupRestore(addonId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary  website backup restore
*/
export const useCodeguardWebsiteBackupRestore = (options) => {
    const mutationOptions = getCodeguardWebsiteBackupRestoreMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns an oauth login URL that can be used to access Sitelock dashboard for a user.
 * @summary sso
 */
export const addonsSitelockSso = (addonId, options) => {
    return axios.get(`/v1/addons/sitelock/${addonId}/sso`, options);
};
export const getAddonsSitelockSsoQueryKey = (addonId) => {
    return [`/v1/addons/sitelock/${addonId}/sso`];
};
export const getAddonsSitelockSsoQueryOptions = (addonId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getAddonsSitelockSsoQueryKey(addonId);
    const queryFn = ({ signal }) => addonsSitelockSso(addonId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(addonId) }, queryOptions);
};
/**
 * @summary sso
 */
export function useAddonsSitelockSso(addonId, options) {
    const queryOptions = getAddonsSitelockSsoQueryOptions(addonId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Backup initiate
 * @summary Backup initiate
 */
export const backupInitiate = (addonId, backupInitiateBody, options) => {
    return axios.post(`/v1/addons/${addonId}/backup`, backupInitiateBody, options);
};
export const getBackupInitiateMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { addonId, data } = props !== null && props !== void 0 ? props : {};
        return backupInitiate(addonId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Backup initiate
*/
export const useBackupInitiate = (options) => {
    const mutationOptions = getBackupInitiateMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Backup status
 * @summary Backup status
 */
export const backupStatus = (addonId, params, options) => {
    return axios.get(`/v1/addons/${addonId}/backup`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getBackupStatusQueryKey = (addonId, params) => {
    return [`/v1/addons/${addonId}/backup`, ...(params ? [params] : [])];
};
export const getBackupStatusQueryOptions = (addonId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getBackupStatusQueryKey(addonId, params);
    const queryFn = ({ signal }) => backupStatus(addonId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(addonId) }, queryOptions);
};
/**
 * @summary Backup status
 */
export function useBackupStatus(addonId, params, options) {
    const queryOptions = getBackupStatusQueryOptions(addonId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Deprecated, use backup_list_v2 instead - Returns backup list
 * @deprecated
 * @summary Backup list
 */
export const backupList = (addonId, params, options) => {
    return axios.get(`/v1/addons/${addonId}/backup/list`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getBackupListQueryKey = (addonId, params) => {
    return [`/v1/addons/${addonId}/backup/list`, ...(params ? [params] : [])];
};
export const getBackupListQueryOptions = (addonId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getBackupListQueryKey(addonId, params);
    const queryFn = ({ signal }) => backupList(addonId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(addonId) }, queryOptions);
};
/**
 * @deprecated
 * @summary Backup list
 */
export function useBackupList(addonId, params, options) {
    const queryOptions = getBackupListQueryOptions(addonId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Decom and delete cloudflare basic addon
 * @summary Uninstall cloudflare basic addon
 */
export const addonsCloudflare = (addonId, options) => {
    return axios.delete(`/v1/addons/${addonId}/cloudflare`, options);
};
export const getAddonsCloudflareMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { addonId } = props !== null && props !== void 0 ? props : {};
        return addonsCloudflare(addonId, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Uninstall cloudflare basic addon
*/
export const useAddonsCloudflare = (options) => {
    const mutationOptions = getAddonsCloudflareMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns addon information
 * @summary info
 */
export const addonsInfo = (addonId, options) => {
    return axios.get(`/v1/addons/${addonId}/info`, options);
};
export const getAddonsInfoQueryKey = (addonId) => {
    return [`/v1/addons/${addonId}/info`];
};
export const getAddonsInfoQueryOptions = (addonId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getAddonsInfoQueryKey(addonId);
    const queryFn = ({ signal }) => addonsInfo(addonId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(addonId) }, queryOptions);
};
/**
 * @summary info
 */
export function useAddonsInfo(addonId, options) {
    const queryOptions = getAddonsInfoQueryOptions(addonId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Runs the validate_addon_state jetpack addon action to update is_connected which we return back to the client
 * @summary sso
 */
export const addonsJetpackValidate = (addonId, options) => {
    return axios.post(`/v1/addons/${addonId}/jetpack/validate`, undefined, options);
};
export const getAddonsJetpackValidateMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { addonId } = props !== null && props !== void 0 ? props : {};
        return addonsJetpackValidate(addonId, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary sso
*/
export const useAddonsJetpackValidate = (options) => {
    const mutationOptions = getAddonsJetpackValidateMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns spamexperts sso url
 * @summary info
 */
export const addonsSpamexpertsSso = (addonId, options) => {
    return axios.get(`/v1/addons/${addonId}/spamexperts/sso`, options);
};
export const getAddonsSpamexpertsSsoQueryKey = (addonId) => {
    return [`/v1/addons/${addonId}/spamexperts/sso`];
};
export const getAddonsSpamexpertsSsoQueryOptions = (addonId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getAddonsSpamexpertsSsoQueryKey(addonId);
    const queryFn = ({ signal }) => addonsSpamexpertsSso(addonId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(addonId) }, queryOptions);
};
/**
 * @summary info
 */
export function useAddonsSpamexpertsSso(addonId, options) {
    const queryOptions = getAddonsSpamexpertsSsoQueryOptions(addonId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns WebZai SSO URL
 * @summary webzai sso
 */
export const webzaiSso = (addonId, options) => {
    return axios.get(`/v1/addons/${addonId}/webzai/sso`, options);
};
export const getWebzaiSsoQueryKey = (addonId) => {
    return [`/v1/addons/${addonId}/webzai/sso`];
};
export const getWebzaiSsoQueryOptions = (addonId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getWebzaiSsoQueryKey(addonId);
    const queryFn = ({ signal }) => webzaiSso(addonId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(addonId) }, queryOptions);
};
/**
 * @summary webzai sso
 */
export function useWebzaiSso(addonId, options) {
    const queryOptions = getWebzaiSsoQueryOptions(addonId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns Weebly SSO URL
 * @summary weebly sso
 */
export const weeblySso = (addonId, options) => {
    return axios.get(`/v1/addons/${addonId}/weebly/sso`, options);
};
export const getWeeblySsoQueryKey = (addonId) => {
    return [`/v1/addons/${addonId}/weebly/sso`];
};
export const getWeeblySsoQueryOptions = (addonId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getWeeblySsoQueryKey(addonId);
    const queryFn = ({ signal }) => weeblySso(addonId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(addonId) }, queryOptions);
};
/**
 * @summary weebly sso
 */
export function useWeeblySso(addonId, options) {
    const queryOptions = getWeeblySsoQueryOptions(addonId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Get domain info
 * @summary domain info
 */
export const domainInfo = (domainId, options) => {
    return axios.get(`/v1/domains/${domainId}`, options);
};
export const getDomainInfoQueryKey = (domainId) => {
    return [`/v1/domains/${domainId}`];
};
export const getDomainInfoQueryOptions = (domainId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getDomainInfoQueryKey(domainId);
    const queryFn = ({ signal }) => domainInfo(domainId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(domainId) }, queryOptions);
};
/**
 * @summary domain info
 */
export function useDomainInfo(domainId, options) {
    const queryOptions = getDomainInfoQueryOptions(domainId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns the certificates for a given domain name or id
 * @summary domain cert list
 */
export const domainCerts = (domainId, options) => {
    return axios.get(`/v1/domains/${domainId}/certs`, options);
};
export const getDomainCertsQueryKey = (domainId) => {
    return [`/v1/domains/${domainId}/certs`];
};
export const getDomainCertsQueryOptions = (domainId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getDomainCertsQueryKey(domainId);
    const queryFn = ({ signal }) => domainCerts(domainId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(domainId) }, queryOptions);
};
/**
 * @summary domain cert list
 */
export function useDomainCerts(domainId, options) {
    const queryOptions = getDomainCertsQueryOptions(domainId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Install and enable a certificate for a given domain
 * @summary domain cert install
 */
export const domainCertInstall = (domainId, domainCertInstallBody, options) => {
    return axios.post(`/v1/domains/${domainId}/certs`, domainCertInstallBody, options);
};
export const getDomainCertInstallMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { domainId, data } = props !== null && props !== void 0 ? props : {};
        return domainCertInstall(domainId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary domain cert install
*/
export const useDomainCertInstall = (options) => {
    const mutationOptions = getDomainCertInstallMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Install a certificate for a given domain name or id
 * @summary domain certs
 */
export const domainCertUpdate = (domainId, domainCertUpdateBody, options) => {
    return axios.put(`/v1/domains/${domainId}/certs`, domainCertUpdateBody, options);
};
export const getDomainCertUpdateMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { domainId, data } = props !== null && props !== void 0 ? props : {};
        return domainCertUpdate(domainId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary domain certs
*/
export const useDomainCertUpdate = (options) => {
    const mutationOptions = getDomainCertUpdateMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Uninstall a certificate for a given domain name or id
 * @summary domain cert uninstall
 */
export const domainCertUninstall = (domainId, options) => {
    return axios.delete(`/v1/domains/${domainId}/certs`, options);
};
export const getDomainCertUninstallMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { domainId } = props !== null && props !== void 0 ? props : {};
        return domainCertUninstall(domainId, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary domain cert uninstall
*/
export const useDomainCertUninstall = (options) => {
    const mutationOptions = getDomainCertUninstallMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Deleting dns records to the specified domain
 * @summary delete zone record
 */
export const domainDnseditor = (domainId, domainDnseditorBody, options) => {
    return axios.delete(`/v1/domains/${domainId}/dns-editor`, Object.assign({ data: domainDnseditorBody }, options));
};
export const getDomainDnseditorMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { domainId, data } = props !== null && props !== void 0 ? props : {};
        return domainDnseditor(domainId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary delete zone record
*/
export const useDomainDnseditor = (options) => {
    const mutationOptions = getDomainDnseditorMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns all the types of DNS records that are managable to that domain or id
 * @summary Manage your nameservers and advanced DNS records.
 */
export const domainDnseditorList = (domainId, options) => {
    return axios.get(`/v1/domains/${domainId}/dns-editor`, options);
};
export const getDomainDnseditorListQueryKey = (domainId) => {
    return [`/v1/domains/${domainId}/dns-editor`];
};
export const getDomainDnseditorListQueryOptions = (domainId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getDomainDnseditorListQueryKey(domainId);
    const queryFn = ({ signal }) => domainDnseditorList(domainId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(domainId) }, queryOptions);
};
/**
 * @summary Manage your nameservers and advanced DNS records.
 */
export function useDomainDnseditorList(domainId, options) {
    const queryOptions = getDomainDnseditorListQueryOptions(domainId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Adding dns records to the specified domain
 * @summary add dns zone record
 */
export const domainDnseditorAdd = (domainId, domainDnseditorAddBody, options) => {
    return axios.post(`/v1/domains/${domainId}/dns-editor`, domainDnseditorAddBody, options);
};
export const getDomainDnseditorAddMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { domainId, data } = props !== null && props !== void 0 ? props : {};
        return domainDnseditorAdd(domainId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary add dns zone record
*/
export const useDomainDnseditorAdd = (options) => {
    const mutationOptions = getDomainDnseditorAddMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Editing dns records to the specified domain
 * @summary edit dns zone record
 */
export const domainDnseditorEdit = (domainId, domainDnseditorEditBody, options) => {
    return axios.put(`/v1/domains/${domainId}/dns-editor`, domainDnseditorEditBody, options);
};
export const getDomainDnseditorEditMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { domainId, data } = props !== null && props !== void 0 ? props : {};
        return domainDnseditorEdit(domainId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary edit dns zone record
*/
export const useDomainDnseditorEdit = (options) => {
    const mutationOptions = getDomainDnseditorEditMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns all the types of DNS records to default state on that domain or id
 * @summary Reset your nameservers and advanced DNS records.
 */
export const domainDnszoneReset = (domainId, options) => {
    return axios.get(`/v1/domains/${domainId}/dns-zone-reset`, options);
};
export const getDomainDnszoneResetQueryKey = (domainId) => {
    return [`/v1/domains/${domainId}/dns-zone-reset`];
};
export const getDomainDnszoneResetQueryOptions = (domainId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getDomainDnszoneResetQueryKey(domainId);
    const queryFn = ({ signal }) => domainDnszoneReset(domainId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(domainId) }, queryOptions);
};
/**
 * @summary Reset your nameservers and advanced DNS records.
 */
export function useDomainDnszoneReset(domainId, options) {
    const queryOptions = getDomainDnszoneResetQueryOptions(domainId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Access logs
 * @summary Access logs
 */
export const accessLogs = (domainId, params, options) => {
    return axios.get(`/v1/domains/${domainId}/logs/access`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getAccessLogsQueryKey = (domainId, params) => {
    return [`/v1/domains/${domainId}/logs/access`, ...(params ? [params] : [])];
};
export const getAccessLogsQueryOptions = (domainId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getAccessLogsQueryKey(domainId, params);
    const queryFn = ({ signal }) => accessLogs(domainId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(domainId) }, queryOptions);
};
/**
 * @summary Access logs
 */
export function useAccessLogs(domainId, params, options) {
    const queryOptions = getAccessLogsQueryOptions(domainId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Unassign a domain name
 * @summary domain unassign
 */
export const domainUnassign = (domainId, options) => {
    return axios.post(`/v1/domains/${domainId}/unassign`, undefined, options);
};
export const getDomainUnassignMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { domainId } = props !== null && props !== void 0 ? props : {};
        return domainUnassign(domainId, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary domain unassign
*/
export const useDomainUnassign = (options) => {
    const mutationOptions = getDomainUnassignMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns a url for navigating to dns zone editor.
 * @summary domain zone editor url
 */
export const domainZoneeditorUrl = (domainId, options) => {
    return axios.get(`/v1/domains/${domainId}/zoneeditor-url`, options);
};
export const getDomainZoneeditorUrlQueryKey = (domainId) => {
    return [`/v1/domains/${domainId}/zoneeditor-url`];
};
export const getDomainZoneeditorUrlQueryOptions = (domainId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getDomainZoneeditorUrlQueryKey(domainId);
    const queryFn = ({ signal }) => domainZoneeditorUrl(domainId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(domainId) }, queryOptions);
};
/**
 * @summary domain zone editor url
 */
export function useDomainZoneeditorUrl(domainId, options) {
    const queryOptions = getDomainZoneeditorUrlQueryOptions(domainId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns HAL hosting account-level information
 * @summary HAL Hosting Account Info
 */
export const hostingAccount = (hostingId, options) => {
    return axios.get(`/v1/hosting/${hostingId}`, options);
};
export const getHostingAccountQueryKey = (hostingId) => {
    return [`/v1/hosting/${hostingId}`];
};
export const getHostingAccountQueryOptions = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHostingAccountQueryKey(hostingId);
    const queryFn = ({ signal }) => hostingAccount(hostingId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary HAL Hosting Account Info
 */
export function useHostingAccount(hostingId, options) {
    const queryOptions = getHostingAccountQueryOptions(hostingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns a list of activities log
 * @summary To get all the recent activities log on user account level
 */
export const activityLog = (hostingId, params, options) => {
    return axios.get(`/v1/hosting/${hostingId}/activity-log`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getActivityLogQueryKey = (hostingId, params) => {
    return [`/v1/hosting/${hostingId}/activity-log`, ...(params ? [params] : [])];
};
export const getActivityLogQueryOptions = (hostingId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getActivityLogQueryKey(hostingId, params);
    const queryFn = ({ signal }) => activityLog(hostingId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary To get all the recent activities log on user account level
 */
export function useActivityLog(hostingId, params, options) {
    const queryOptions = getActivityLogQueryOptions(hostingId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns a list of addons.
 * @summary addon list
 */
export const hostingAddons = (hostingId, params, options) => {
    return axios.get(`/v1/hosting/${hostingId}/addons`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getHostingAddonsQueryKey = (hostingId, params) => {
    return [`/v1/hosting/${hostingId}/addons`, ...(params ? [params] : [])];
};
export const getHostingAddonsQueryOptions = (hostingId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHostingAddonsQueryKey(hostingId, params);
    const queryFn = ({ signal }) => hostingAddons(hostingId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary addon list
 */
export function useHostingAddons(hostingId, params, options) {
    const queryOptions = getHostingAddonsQueryOptions(hostingId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Checks for dns already exists
 * @summary advanced hosting dns check
 */
export const hostingAdvancedDns = (hostingId, params, options) => {
    return axios.get(`/v1/hosting/${hostingId}/advanced/dns`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getHostingAdvancedDnsQueryKey = (hostingId, params) => {
    return [`/v1/hosting/${hostingId}/advanced/dns`, ...(params ? [params] : [])];
};
export const getHostingAdvancedDnsQueryOptions = (hostingId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHostingAdvancedDnsQueryKey(hostingId, params);
    const queryFn = ({ signal }) => hostingAdvancedDns(hostingId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary advanced hosting dns check
 */
export function useHostingAdvancedDns(hostingId, params, options) {
    const queryOptions = getHostingAdvancedDnsQueryOptions(hostingId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Update DNS Zone Info if it doesnt exists
 * @summary advanced hosting dns zone update
 */
export const hostingAdvancedDnsUpdate = (hostingId, hostingAdvancedDnsUpdateBody, options) => {
    return axios.post(`/v1/hosting/${hostingId}/advanced/dns`, hostingAdvancedDnsUpdateBody, options);
};
export const getHostingAdvancedDnsUpdateMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return hostingAdvancedDnsUpdate(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary advanced hosting dns zone update
*/
export const useHostingAdvancedDnsUpdate = (options) => {
    const mutationOptions = getHostingAdvancedDnsUpdateMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * To check for the domain services configuration
 * @summary Domain services configuration check
 */
export const hostingAdvancedDomainServicesCheck = (hostingId, options) => {
    return axios.get(`/v1/hosting/${hostingId}/advanced/domain/services`, options);
};
export const getHostingAdvancedDomainServicesCheckQueryKey = (hostingId) => {
    return [`/v1/hosting/${hostingId}/advanced/domain/services`];
};
export const getHostingAdvancedDomainServicesCheckQueryOptions = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHostingAdvancedDomainServicesCheckQueryKey(hostingId);
    const queryFn = ({ signal }) => hostingAdvancedDomainServicesCheck(hostingId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary Domain services configuration check
 */
export function useHostingAdvancedDomainServicesCheck(hostingId, options) {
    const queryOptions = getHostingAdvancedDomainServicesCheckQueryOptions(hostingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * To configure domain services
 * @summary Domain services configuration
 */
export const hostingAdvancedDomainServices = (hostingId, hostingAdvancedDomainServicesBody, options) => {
    return axios.post(`/v1/hosting/${hostingId}/advanced/domain/services`, hostingAdvancedDomainServicesBody, options);
};
export const getHostingAdvancedDomainServicesMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return hostingAdvancedDomainServices(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Domain services configuration
*/
export const useHostingAdvancedDomainServices = (options) => {
    const mutationOptions = getHostingAdvancedDomainServicesMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns the hosting server info
 * @summary server status/info
 */
export const hostingAdvancedServer = (hostingId, options) => {
    return axios.get(`/v1/hosting/${hostingId}/advanced/server`, options);
};
export const getHostingAdvancedServerQueryKey = (hostingId) => {
    return [`/v1/hosting/${hostingId}/advanced/server`];
};
export const getHostingAdvancedServerQueryOptions = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHostingAdvancedServerQueryKey(hostingId);
    const queryFn = ({ signal }) => hostingAdvancedServer(hostingId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary server status/info
 */
export function useHostingAdvancedServer(hostingId, options) {
    const queryOptions = getHostingAdvancedServerQueryOptions(hostingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Allows for managing server status
 * @summary server_status
 */
export const hostingAdvancedServerStatus = (hostingId, hostingAdvancedServerStatusBody, options) => {
    return axios.put(`/v1/hosting/${hostingId}/advanced/server`, hostingAdvancedServerStatusBody, options);
};
export const getHostingAdvancedServerStatusMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return hostingAdvancedServerStatus(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary server_status
*/
export const useHostingAdvancedServerStatus = (options) => {
    const mutationOptions = getHostingAdvancedServerStatusMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Update user account's password
 * @summary Update user account password
 */
export const hostingAdvancedPassword = (hostingId, hostingAdvancedPasswordBody, options) => {
    return axios.put(`/v1/hosting/${hostingId}/advanced/server/password`, hostingAdvancedPasswordBody, options);
};
export const getHostingAdvancedPasswordMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return hostingAdvancedPassword(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Update user account password
*/
export const useHostingAdvancedPassword = (options) => {
    const mutationOptions = getHostingAdvancedPasswordMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns the hosting sso_whm login url
 * @summary hosting sso_whm
 */
export const hostingAdvancedSsoWhm = (hostingId, options) => {
    return axios.get(`/v1/hosting/${hostingId}/advanced/sso_whm`, options);
};
export const getHostingAdvancedSsoWhmQueryKey = (hostingId) => {
    return [`/v1/hosting/${hostingId}/advanced/sso_whm`];
};
export const getHostingAdvancedSsoWhmQueryOptions = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHostingAdvancedSsoWhmQueryKey(hostingId);
    const queryFn = ({ signal }) => hostingAdvancedSsoWhm(hostingId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary hosting sso_whm
 */
export function useHostingAdvancedSsoWhm(hostingId, options) {
    const queryOptions = getHostingAdvancedSsoWhmQueryOptions(hostingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns the hosting system_console url
 * @summary hosting system_console
 */
export const hostingAdvancedSystemConsole = (hostingId, options) => {
    return axios.get(`/v1/hosting/${hostingId}/advanced/system-console`, options);
};
export const getHostingAdvancedSystemConsoleQueryKey = (hostingId) => {
    return [`/v1/hosting/${hostingId}/advanced/system-console`];
};
export const getHostingAdvancedSystemConsoleQueryOptions = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHostingAdvancedSystemConsoleQueryKey(hostingId);
    const queryFn = ({ signal }) => hostingAdvancedSystemConsole(hostingId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary hosting system_console
 */
export function useHostingAdvancedSystemConsole(hostingId, options) {
    const queryOptions = getHostingAdvancedSystemConsoleQueryOptions(hostingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns the hosting capabilities
 * @summary hosting capabilities
 */
export const hostingCapabilities = (hostingId, options) => {
    return axios.get(`/v1/hosting/${hostingId}/capabilities`, options);
};
export const getHostingCapabilitiesQueryKey = (hostingId) => {
    return [`/v1/hosting/${hostingId}/capabilities`];
};
export const getHostingCapabilitiesQueryOptions = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHostingCapabilitiesQueryKey(hostingId);
    const queryFn = ({ signal }) => hostingCapabilities(hostingId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary hosting capabilities
 */
export function useHostingCapabilities(hostingId, options) {
    const queryOptions = getHostingCapabilitiesQueryOptions(hostingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns a list of cron jobs
 * @summary cron_list
 */
export const listCrons = (hostingId, options) => {
    return axios.get(`/v1/hosting/${hostingId}/crontab`, options);
};
export const getListCronsQueryKey = (hostingId) => {
    return [`/v1/hosting/${hostingId}/crontab`];
};
export const getListCronsQueryOptions = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getListCronsQueryKey(hostingId);
    const queryFn = ({ signal }) => listCrons(hostingId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary cron_list
 */
export function useListCrons(hostingId, options) {
    const queryOptions = getListCronsQueryOptions(hostingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Adds a new cron job
 * @summary cron_add
 */
export const addCron = (hostingId, addCronBody, options) => {
    return axios.post(`/v1/hosting/${hostingId}/crontab`, addCronBody, options);
};
export const getAddCronMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return addCron(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary cron_add
*/
export const useAddCron = (options) => {
    const mutationOptions = getAddCronMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Updates a cron job
 * @summary cron_update
 */
export const updateCron = (hostingId, updateCronBody, options) => {
    return axios.put(`/v1/hosting/${hostingId}/crontab`, updateCronBody, options);
};
export const getUpdateCronMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return updateCron(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary cron_update
*/
export const useUpdateCron = (options) => {
    const mutationOptions = getUpdateCronMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Deletes a cron job
 * @summary cron_delete
 */
export const cron = (hostingId, cronBody, options) => {
    return axios.delete(`/v1/hosting/${hostingId}/crontab`, Object.assign({ data: cronBody }, options));
};
export const getCronMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return cron(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary cron_delete
*/
export const useCron = (options) => {
    const mutationOptions = getCronMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Cron last run
 * @summary Cron last run
 */
export const cronLastRun = (hostingId, params, options) => {
    return axios.get(`/v1/hosting/${hostingId}/crontab/last-run`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getCronLastRunQueryKey = (hostingId, params) => {
    return [`/v1/hosting/${hostingId}/crontab/last-run`, ...(params ? [params] : [])];
};
export const getCronLastRunQueryOptions = (hostingId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getCronLastRunQueryKey(hostingId, params);
    const queryFn = ({ signal }) => cronLastRun(hostingId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary Cron last run
 */
export function useCronLastRun(hostingId, params, options) {
    const queryOptions = getCronLastRunQueryOptions(hostingId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Add a new db to an account
 * @summary Create a database for an account
 */
export const dbAdd = (hostingId, dbAddBody, options) => {
    return axios.post(`/v1/hosting/${hostingId}/db`, dbAddBody, options);
};
export const getDbAddMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return dbAdd(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Create a database for an account
*/
export const useDbAdd = (options) => {
    const mutationOptions = getDbAddMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Delete db account
 * @summary Delete db account
 */
export const db = (hostingId, dbBody, options) => {
    return axios.delete(`/v1/hosting/${hostingId}/db`, Object.assign({ data: dbBody }, options));
};
export const getDbMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return db(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Delete db account
*/
export const useDb = (options) => {
    const mutationOptions = getDbMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns a list of Remote IP
 * @summary Returns a list of authorized DB hosts / ips
 */
export const hostingDbAuthorizedHosts = (hostingId, options) => {
    return axios.get(`/v1/hosting/${hostingId}/db/authorized-hosts`, options);
};
export const getHostingDbAuthorizedHostsQueryKey = (hostingId) => {
    return [`/v1/hosting/${hostingId}/db/authorized-hosts`];
};
export const getHostingDbAuthorizedHostsQueryOptions = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHostingDbAuthorizedHostsQueryKey(hostingId);
    const queryFn = ({ signal }) => hostingDbAuthorizedHosts(hostingId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary Returns a list of authorized DB hosts / ips
 */
export function useHostingDbAuthorizedHosts(hostingId, options) {
    const queryOptions = getHostingDbAuthorizedHostsQueryOptions(hostingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Adds an authorized DB host / ip and label
 * @summary Adds an authorized DB host / ip and label
 */
export const hostingDbAuthorizedHostsAdd = (hostingId, hostingDbAuthorizedHostsAddBody, options) => {
    return axios.post(`/v1/hosting/${hostingId}/db/authorized-hosts`, hostingDbAuthorizedHostsAddBody, options);
};
export const getHostingDbAuthorizedHostsAddMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return hostingDbAuthorizedHostsAdd(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Adds an authorized DB host / ip and label
*/
export const useHostingDbAuthorizedHostsAdd = (options) => {
    const mutationOptions = getHostingDbAuthorizedHostsAddMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Updates an authorized DB host / ip or label
 * @summary Updates an authorized DB host / ip or label
 */
export const hostingDbAuthorizedHostsUpdate = (hostingId, hostingDbAuthorizedHostsUpdateBody, options) => {
    return axios.put(`/v1/hosting/${hostingId}/db/authorized-hosts`, hostingDbAuthorizedHostsUpdateBody, options);
};
export const getHostingDbAuthorizedHostsUpdateMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return hostingDbAuthorizedHostsUpdate(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Updates an authorized DB host / ip or label
*/
export const useHostingDbAuthorizedHostsUpdate = (options) => {
    const mutationOptions = getHostingDbAuthorizedHostsUpdateMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * deletes the authorized DB host/ip
 * @summary Deletes an authorized DB host / ip
 */
export const hostingDbAuthorizedHostsDelete = (hostingId, hostingDbAuthorizedHostsDeleteBody, options) => {
    return axios.delete(`/v1/hosting/${hostingId}/db/authorized-hosts`, Object.assign({ data: hostingDbAuthorizedHostsDeleteBody }, options));
};
export const getHostingDbAuthorizedHostsDeleteMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return hostingDbAuthorizedHostsDelete(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Deletes an authorized DB host / ip
*/
export const useHostingDbAuthorizedHostsDelete = (options) => {
    const mutationOptions = getHostingDbAuthorizedHostsDeleteMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Check database.
 * @summary Check database.
 */
export const dbCheckDatabase = (hostingId, dbCheckDatabaseBody, options) => {
    return axios.post(`/v1/hosting/${hostingId}/db/check`, dbCheckDatabaseBody, options);
};
export const getDbCheckDatabaseMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return dbCheckDatabase(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Check database.
*/
export const useDbCheckDatabase = (options) => {
    const mutationOptions = getDbCheckDatabaseMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Repair database.
 * @summary Repair database.
 */
export const repairDatabase = (hostingId, repairDatabaseBody, options) => {
    return axios.post(`/v1/hosting/${hostingId}/db/repair`, repairDatabaseBody, options);
};
export const getRepairDatabaseMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return repairDatabase(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Repair database.
*/
export const useRepairDatabase = (options) => {
    const mutationOptions = getRepairDatabaseMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns a list of db and table limits and usage.
 * @summary DB usage
 */
export const dbUsage = (hostingId, options) => {
    return axios.get(`/v1/hosting/${hostingId}/db/usage`, options);
};
export const getDbUsageQueryKey = (hostingId) => {
    return [`/v1/hosting/${hostingId}/db/usage`];
};
export const getDbUsageQueryOptions = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getDbUsageQueryKey(hostingId);
    const queryFn = ({ signal }) => dbUsage(hostingId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary DB usage
 */
export function useDbUsage(hostingId, options) {
    const queryOptions = getDbUsageQueryOptions(hostingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Update database user password
 * @summary Update database user password
 */
export const dbUserPasswordSet = (hostingId, dbUserPasswordSetBody, options) => {
    return axios.post(`/v1/hosting/${hostingId}/db/user/password`, dbUserPasswordSetBody, options);
};
export const getDbUserPasswordSetMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return dbUserPasswordSet(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Update database user password
*/
export const useDbUserPasswordSet = (options) => {
    const mutationOptions = getDbUserPasswordSetMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Get user privileges on a database.
 * @summary Get user privileges on a database.
 */
export const dbUserPrivsGet = (hostingId, params, options) => {
    return axios.get(`/v1/hosting/${hostingId}/db/user/privileges`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getDbUserPrivsGetQueryKey = (hostingId, params) => {
    return [`/v1/hosting/${hostingId}/db/user/privileges`, ...(params ? [params] : [])];
};
export const getDbUserPrivsGetQueryOptions = (hostingId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getDbUserPrivsGetQueryKey(hostingId, params);
    const queryFn = ({ signal }) => dbUserPrivsGet(hostingId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary Get user privileges on a database.
 */
export function useDbUserPrivsGet(hostingId, params, options) {
    const queryOptions = getDbUserPrivsGetQueryOptions(hostingId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Add/Update user privileges on a database.
 * @summary Add/Update user privileges on a database.
 */
export const dbUserPrivsSet = (hostingId, dbUserPrivsSetBody, options) => {
    return axios.post(`/v1/hosting/${hostingId}/db/user/privileges`, dbUserPrivsSetBody, options);
};
export const getDbUserPrivsSetMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return dbUserPrivsSet(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Add/Update user privileges on a database.
*/
export const useDbUserPrivsSet = (options) => {
    const mutationOptions = getDbUserPrivsSetMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Creates a database user with privileges. The final username cannot exceed 16 characters, and will have the cpanel account username's first eight characters prepended to it.
 * @summary Create a database user with privileges
 */
export const dbUserAdd = (hostingId, dbUserAddBody, options) => {
    return axios.post(`/v1/hosting/${hostingId}/db/users`, dbUserAddBody, options);
};
export const getDbUserAddMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return dbUserAdd(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Create a database user with privileges
*/
export const useDbUserAdd = (options) => {
    const mutationOptions = getDbUserAddMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Delete db user
 * @summary Delete db user
 */
export const dbUserDelete = (hostingId, dbUserDeleteBody, options) => {
    return axios.delete(`/v1/hosting/${hostingId}/db/users`, Object.assign({ data: dbUserDeleteBody }, options));
};
export const getDbUserDeleteMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return dbUserDelete(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Delete db user
*/
export const useDbUserDelete = (options) => {
    const mutationOptions = getDbUserDeleteMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * List all DB users
 * @summary Get list of db users
 */
export const dbUserList = (hostingId, options) => {
    return axios.get(`/v1/hosting/${hostingId}/db/users`, options);
};
export const getDbUserListQueryKey = (hostingId) => {
    return [`/v1/hosting/${hostingId}/db/users`];
};
export const getDbUserListQueryOptions = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getDbUserListQueryKey(hostingId);
    const queryFn = ({ signal }) => dbUserList(hostingId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary Get list of db users
 */
export function useDbUserList(hostingId, options) {
    const queryOptions = getDbUserListQueryOptions(hostingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Rename db user
 * @summary Rename db user
 */
export const dbUserRename = (hostingId, dbUserRenameBody, options) => {
    return axios.put(`/v1/hosting/${hostingId}/db/users`, dbUserRenameBody, options);
};
export const getDbUserRenameMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return dbUserRename(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Rename db user
*/
export const useDbUserRename = (options) => {
    const mutationOptions = getDbUserRenameMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Delete multiple database users / databases
 * @summary Delete multiple database users / databases
 */
export const dbMultipleUserDatabase = (hostingId, dbMultipleUserDatabaseBody, options) => {
    return axios.delete(`/v1/hosting/${hostingId}/db/users/bulk`, Object.assign({ data: dbMultipleUserDatabaseBody }, options));
};
export const getDbMultipleUserDatabaseMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return dbMultipleUserDatabase(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Delete multiple database users / databases
*/
export const useDbMultipleUserDatabase = (options) => {
    const mutationOptions = getDbMultipleUserDatabaseMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Allow user to secure specific folders
 * @summary Allow users to secure specific folders on their websites
 */
export const directoryPrivacy = (hostingId, params, options) => {
    return axios.get(`/v1/hosting/${hostingId}/directoryprivacy`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getDirectoryPrivacyQueryKey = (hostingId, params) => {
    return [`/v1/hosting/${hostingId}/directoryprivacy`, ...(params ? [params] : [])];
};
export const getDirectoryPrivacyQueryOptions = (hostingId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getDirectoryPrivacyQueryKey(hostingId, params);
    const queryFn = ({ signal }) => directoryPrivacy(hostingId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary Allow users to secure specific folders on their websites
 */
export function useDirectoryPrivacy(hostingId, params, options) {
    const queryOptions = getDirectoryPrivacyQueryOptions(hostingId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Allow user to add specific folders
 * @summary Allow users to secure specific folders on their websites
 */
export const addPrivacy = (hostingId, addPrivacyBody, options) => {
    return axios.post(`/v1/hosting/${hostingId}/directoryprivacy`, addPrivacyBody, options);
};
export const getAddPrivacyMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return addPrivacy(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Allow users to secure specific folders on their websites
*/
export const useAddPrivacy = (options) => {
    const mutationOptions = getAddPrivacyMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Allow user to delete specific folders
 * @summary Allow users to delete specific folders on their websites
 */
export const privacy = (hostingId, privacyBody, options) => {
    return axios.delete(`/v1/hosting/${hostingId}/directoryprivacy`, Object.assign({ data: privacyBody }, options));
};
export const getPrivacyMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return privacy(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Allow users to delete specific folders on their websites
*/
export const usePrivacy = (options) => {
    const mutationOptions = getPrivacyMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Allow user to secure specific folders
 * @summary Allow users to edit secure specific folders on their websites
 */
export const editPrivacy = (hostingId, editPrivacyBody, options) => {
    return axios.put(`/v1/hosting/${hostingId}/directoryprivacy`, editPrivacyBody, options);
};
export const getEditPrivacyMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return editPrivacy(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Allow users to edit secure specific folders on their websites
*/
export const useEditPrivacy = (options) => {
    const mutationOptions = getEditPrivacyMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Delete user for password protected directory
 * @summary Delete user for password protected directory
 */
export const privacyUser = (hostingId, privacyUserBody, options) => {
    return axios.delete(`/v1/hosting/${hostingId}/directoryprivacy/user`, Object.assign({ data: privacyUserBody }, options));
};
export const getPrivacyUserMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return privacyUser(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Delete user for password protected directory
*/
export const usePrivacyUser = (options) => {
    const mutationOptions = getPrivacyUserMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Assign the domain
 * @summary Assign the domain
 */
export const hostingDomainAssign = (hostingId, hostingDomainAssignBody, options) => {
    return axios.post(`/v1/hosting/${hostingId}/domain/assign`, hostingDomainAssignBody, options);
};
export const getHostingDomainAssignMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return hostingDomainAssign(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Assign the domain
*/
export const useHostingDomainAssign = (options) => {
    const mutationOptions = getHostingDomainAssignMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * domain availability
 * @summary Domain availability
 */
export const hostingDomainAvailability = (hostingId, params, options) => {
    return axios.get(`/v1/hosting/${hostingId}/domain/availability`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getHostingDomainAvailabilityQueryKey = (hostingId, params) => {
    return [`/v1/hosting/${hostingId}/domain/availability`, ...(params ? [params] : [])];
};
export const getHostingDomainAvailabilityQueryOptions = (hostingId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHostingDomainAvailabilityQueryKey(hostingId, params);
    const queryFn = ({ signal }) => hostingDomainAvailability(hostingId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary Domain availability
 */
export function useHostingDomainAvailability(hostingId, params, options) {
    const queryOptions = getHostingDomainAvailabilityQueryOptions(hostingId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns a list of domains
 * @summary domain list
 */
export const domains = (hostingId, params, options) => {
    return axios.get(`/v1/hosting/${hostingId}/domains`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getDomainsQueryKey = (hostingId, params) => {
    return [`/v1/hosting/${hostingId}/domains`, ...(params ? [params] : [])];
};
export const getDomainsQueryOptions = (hostingId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getDomainsQueryKey(hostingId, params);
    const queryFn = ({ signal }) => domains(hostingId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary domain list
 */
export function useDomains(hostingId, params, options) {
    const queryOptions = getDomainsQueryOptions(hostingId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns the content of the zone file of the domain
 * @summary Export DNS Zone file
 */
export const domainDnsExport = (hostingId, params, options) => {
    return axios.get(`/v1/hosting/${hostingId}/domains/dns/export`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getDomainDnsExportQueryKey = (hostingId, params) => {
    return [`/v1/hosting/${hostingId}/domains/dns/export`, ...(params ? [params] : [])];
};
export const getDomainDnsExportQueryOptions = (hostingId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getDomainDnsExportQueryKey(hostingId, params);
    const queryFn = ({ signal }) => domainDnsExport(hostingId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary Export DNS Zone file
 */
export function useDomainDnsExport(hostingId, params, options) {
    const queryOptions = getDomainDnsExportQueryOptions(hostingId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns the content of the zone file
 * @summary Import DNS Zone file
 */
export const domainDnsImport = (hostingId, domainDnsImportBody, params, options) => {
    const formData = new FormData();
    formData.append('file', domainDnsImportBody.file);
    return axios.post(`/v1/hosting/${hostingId}/domains/dns/import`, formData, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getDomainDnsImportMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data, params } = props !== null && props !== void 0 ? props : {};
        return domainDnsImport(hostingId, data, params, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Import DNS Zone file
*/
export const useDomainDnsImport = (options) => {
    const mutationOptions = getDomainDnsImportMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Unassign the domain associated with the hosting account
 * @summary Unassign the domain
 */
export const hostingDomainsUnassign = (hostingId, hostingDomainsUnassignBody, options) => {
    return axios.post(`/v1/hosting/${hostingId}/domains/unassign`, hostingDomainsUnassignBody, options);
};
export const getHostingDomainsUnassignMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return hostingDomainsUnassign(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Unassign the domain
*/
export const useHostingDomainsUnassign = (options) => {
    const mutationOptions = getHostingDomainsUnassignMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns info about an existing ecommerce addon otherwise it returns null
 * @summary ecommerce info
 */
export const hostingEcommerceInfo = (hostingId, options) => {
    return axios.get(`/v1/hosting/${hostingId}/ecommerce`, options);
};
export const getHostingEcommerceInfoQueryKey = (hostingId) => {
    return [`/v1/hosting/${hostingId}/ecommerce`];
};
export const getHostingEcommerceInfoQueryOptions = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHostingEcommerceInfoQueryKey(hostingId);
    const queryFn = ({ signal }) => hostingEcommerceInfo(hostingId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary ecommerce info
 */
export function useHostingEcommerceInfo(hostingId, options) {
    const queryOptions = getHostingEcommerceInfoQueryOptions(hostingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Use to add a new email box, domainalias, alias, forwarder, discard, pipe or list
 * @summary email add
 */
export const hostingEmailAdd = (hostingId, hostingEmailAddBody, options) => {
    return axios.post(`/v1/hosting/${hostingId}/emails`, hostingEmailAddBody, options);
};
export const getHostingEmailAddMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return hostingEmailAdd(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary email add
*/
export const useHostingEmailAdd = (options) => {
    const mutationOptions = getHostingEmailAddMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Deletes an email account by address
 * @summary email delete
 */
export const hostingEmailDelete = (hostingId, params, options) => {
    return axios.delete(`/v1/hosting/${hostingId}/emails`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getHostingEmailDeleteMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, params } = props !== null && props !== void 0 ? props : {};
        return hostingEmailDelete(hostingId, params, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary email delete
*/
export const useHostingEmailDelete = (options) => {
    const mutationOptions = getHostingEmailDeleteMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Lists existing email resources by type
 * @summary email list
 */
export const hostingEmailList = (hostingId, options) => {
    return axios.get(`/v1/hosting/${hostingId}/emails`, options);
};
export const getHostingEmailListQueryKey = (hostingId) => {
    return [`/v1/hosting/${hostingId}/emails`];
};
export const getHostingEmailListQueryOptions = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHostingEmailListQueryKey(hostingId);
    const queryFn = ({ signal }) => hostingEmailList(hostingId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary email list
 */
export function useHostingEmailList(hostingId, options) {
    const queryOptions = getHostingEmailListQueryOptions(hostingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Updates an email account
 * @summary email update
 */
export const hostingEmailUpdate = (hostingId, hostingEmailUpdateBody, options) => {
    return axios.put(`/v1/hosting/${hostingId}/emails`, hostingEmailUpdateBody, options);
};
export const getHostingEmailUpdateMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return hostingEmailUpdate(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary email update
*/
export const useHostingEmailUpdate = (options) => {
    const mutationOptions = getHostingEmailUpdateMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Lists existing email account and domain forwarders
 * @summary email forwarders lists
 */
export const hostingEmailForwardersList = (hostingId, params, options) => {
    return axios.get(`/v1/hosting/${hostingId}/emails/forwarders`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getHostingEmailForwardersListQueryKey = (hostingId, params) => {
    return [`/v1/hosting/${hostingId}/emails/forwarders`, ...(params ? [params] : [])];
};
export const getHostingEmailForwardersListQueryOptions = (hostingId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHostingEmailForwardersListQueryKey(hostingId, params);
    const queryFn = ({ signal }) => hostingEmailForwardersList(hostingId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary email forwarders lists
 */
export function useHostingEmailForwardersList(hostingId, params, options) {
    const queryOptions = getHostingEmailForwardersListQueryOptions(hostingId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Add a new forwarder by either account or domain
 * @summary NOT YET IMPLEMENTED - email forwarder add
 */
export const hostingEmailForwarderAdd = (hostingId, hostingEmailForwarderAddBody, options) => {
    return axios.post(`/v1/hosting/${hostingId}/emails/forwarders`, hostingEmailForwarderAddBody, options);
};
export const getHostingEmailForwarderAddMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return hostingEmailForwarderAdd(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary NOT YET IMPLEMENTED - email forwarder add
*/
export const useHostingEmailForwarderAdd = (options) => {
    const mutationOptions = getHostingEmailForwarderAddMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Delete email forwarder
 * @summary NOT YET IMPLEMENTED - email forwarder delete
 */
export const hostingEmailForwarderDelete = (hostingId, params, options) => {
    return axios.delete(`/v1/hosting/${hostingId}/emails/forwarders`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getHostingEmailForwarderDeleteMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, params } = props !== null && props !== void 0 ? props : {};
        return hostingEmailForwarderDelete(hostingId, params, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary NOT YET IMPLEMENTED - email forwarder delete
*/
export const useHostingEmailForwarderDelete = (options) => {
    const mutationOptions = getHostingEmailForwarderDeleteMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns a SSO login token for an email account by using the query parameters.
 * @summary email sso
 */
export const emailSso = (hostingId, params, options) => {
    return axios.get(`/v1/hosting/${hostingId}/emails/sso`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getEmailSsoQueryKey = (hostingId, params) => {
    return [`/v1/hosting/${hostingId}/emails/sso`, ...(params ? [params] : [])];
};
export const getEmailSsoQueryOptions = (hostingId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getEmailSsoQueryKey(hostingId, params);
    const queryFn = ({ signal }) => emailSso(hostingId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary email sso
 */
export function useEmailSso(hostingId, params, options) {
    const queryOptions = getEmailSsoQueryOptions(hostingId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Suspend or unsuspend an email accounts ability to send and receive email
 * @summary email suspend
 */
export const hostingEmailSuspend = (hostingId, hostingEmailSuspendBody, options) => {
    return axios.post(`/v1/hosting/${hostingId}/emails/suspend`, hostingEmailSuspendBody, options);
};
export const getHostingEmailSuspendMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return hostingEmailSuspend(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary email suspend
*/
export const useHostingEmailSuspend = (options) => {
    const mutationOptions = getHostingEmailSuspendMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Lists existing email address folders
 * @summary email folder list
 */
export const hostingEmailFolderList = (hostingId, address, options) => {
    return axios.get(`/v1/hosting/${hostingId}/emails/${address}/folders`, options);
};
export const getHostingEmailFolderListQueryKey = (hostingId, address) => {
    return [`/v1/hosting/${hostingId}/emails/${address}/folders`];
};
export const getHostingEmailFolderListQueryOptions = (hostingId, address, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHostingEmailFolderListQueryKey(hostingId, address);
    const queryFn = ({ signal }) => hostingEmailFolderList(hostingId, address, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId && address) }, queryOptions);
};
/**
 * @summary email folder list
 */
export function useHostingEmailFolderList(hostingId, address, options) {
    const queryOptions = getHostingEmailFolderListQueryOptions(hostingId, address, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Re-enforces correct ownership on user dirs and files
 * @summary Fix file ownership
 */
export const hostingFixownership = (hostingId, options) => {
    return axios.post(`/v1/hosting/${hostingId}/fixownership`, undefined, options);
};
export const getHostingFixownershipMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId } = props !== null && props !== void 0 ? props : {};
        return hostingFixownership(hostingId, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Fix file ownership
*/
export const useHostingFixownership = (options) => {
    const mutationOptions = getHostingFixownershipMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns a list of FTP accounts.
 * @summary ftp list
 */
export const hostingFtpList = (hostingId, options) => {
    return axios.get(`/v1/hosting/${hostingId}/ftp`, options);
};
export const getHostingFtpListQueryKey = (hostingId) => {
    return [`/v1/hosting/${hostingId}/ftp`];
};
export const getHostingFtpListQueryOptions = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHostingFtpListQueryKey(hostingId);
    const queryFn = ({ signal }) => hostingFtpList(hostingId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary ftp list
 */
export function useHostingFtpList(hostingId, options) {
    const queryOptions = getHostingFtpListQueryOptions(hostingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Add ftp account
 * @summary Add ftp account
 */
export const hostingFtpAdd = (hostingId, hostingFtpAddBody, options) => {
    return axios.post(`/v1/hosting/${hostingId}/ftp`, hostingFtpAddBody, options);
};
export const getHostingFtpAddMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return hostingFtpAdd(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Add ftp account
*/
export const useHostingFtpAdd = (options) => {
    const mutationOptions = getHostingFtpAddMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Update ftp account
 * @summary Update ftp account
 */
export const hostingFtpUpdate = (hostingId, hostingFtpUpdateBody, options) => {
    return axios.put(`/v1/hosting/${hostingId}/ftp`, hostingFtpUpdateBody, options);
};
export const getHostingFtpUpdateMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return hostingFtpUpdate(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Update ftp account
*/
export const useHostingFtpUpdate = (options) => {
    const mutationOptions = getHostingFtpUpdateMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Delete ftp account
 * @summary Delete ftp account
 */
export const hostingFtp = (hostingId, hostingFtpBody, options) => {
    return axios.delete(`/v1/hosting/${hostingId}/ftp`, Object.assign({ data: hostingFtpBody }, options));
};
export const getHostingFtpMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return hostingFtp(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Delete ftp account
*/
export const useHostingFtp = (options) => {
    const mutationOptions = getHostingFtpMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns a list of Git repositories associated
 * @summary List Git repositories
 */
export const hostingRepoList = (hostingId, options) => {
    return axios.get(`/v1/hosting/${hostingId}/git-repos`, options);
};
export const getHostingRepoListQueryKey = (hostingId) => {
    return [`/v1/hosting/${hostingId}/git-repos`];
};
export const getHostingRepoListQueryOptions = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHostingRepoListQueryKey(hostingId);
    const queryFn = ({ signal }) => hostingRepoList(hostingId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary List Git repositories
 */
export function useHostingRepoList(hostingId, options) {
    const queryOptions = getHostingRepoListQueryOptions(hostingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Clone a new Git repo or pull latest changes into the given path (deployment)
 * @summary Clone or pull Git repository(deploy)
 */
export const hostingRepoSync = (hostingId, hostingRepoSyncBody, options) => {
    return axios.post(`/v1/hosting/${hostingId}/git-repos`, hostingRepoSyncBody, options);
};
export const getHostingRepoSyncMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return hostingRepoSync(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Clone or pull Git repository(deploy)
*/
export const useHostingRepoSync = (options) => {
    const mutationOptions = getHostingRepoSyncMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Deletes the local clone of a Git repository at the specified path
 * @summary Delete Git repository
 */
export const hostingRepo = (hostingId, hostingRepoBody, options) => {
    return axios.delete(`/v1/hosting/${hostingId}/git-repos`, Object.assign({ data: hostingRepoBody }, options));
};
export const getHostingRepoMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return hostingRepo(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Delete Git repository
*/
export const useHostingRepo = (options) => {
    const mutationOptions = getHostingRepoMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns the deployment log for a Git repository identified by the path
 * @summary View Git repository deployment log
 */
export const hostingRepoLog = (hostingId, params, options) => {
    return axios.get(`/v1/hosting/${hostingId}/git-repos/log`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getHostingRepoLogQueryKey = (hostingId, params) => {
    return [`/v1/hosting/${hostingId}/git-repos/log`, ...(params ? [params] : [])];
};
export const getHostingRepoLogQueryOptions = (hostingId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHostingRepoLogQueryKey(hostingId, params);
    const queryFn = ({ signal }) => hostingRepoLog(hostingId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary View Git repository deployment log
 */
export function useHostingRepoLog(hostingId, params, options) {
    const queryOptions = getHostingRepoLogQueryOptions(hostingId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Hotlink configuration details
 * @summary Hotlink configuration details
 */
export const hotlinkconfigDetails = (hostingId, params, options) => {
    return axios.get(`/v1/hosting/${hostingId}/hotlinkconfig`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getHotlinkconfigDetailsQueryKey = (hostingId, params) => {
    return [`/v1/hosting/${hostingId}/hotlinkconfig`, ...(params ? [params] : [])];
};
export const getHotlinkconfigDetailsQueryOptions = (hostingId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHotlinkconfigDetailsQueryKey(hostingId, params);
    const queryFn = ({ signal }) => hotlinkconfigDetails(hostingId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary Hotlink configuration details
 */
export function useHotlinkconfigDetails(hostingId, params, options) {
    const queryOptions = getHotlinkconfigDetailsQueryOptions(hostingId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Add/Update hotlink configuration
 * @summary Add/Update hotlink configuration
 */
export const hotlinkconfigAdd = (hostingId, hotlinkconfigAddBody, options) => {
    return axios.post(`/v1/hosting/${hostingId}/hotlinkconfig`, hotlinkconfigAddBody, options);
};
export const getHotlinkconfigAddMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return hotlinkconfigAdd(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Add/Update hotlink configuration
*/
export const useHotlinkconfigAdd = (options) => {
    const mutationOptions = getHotlinkconfigAddMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Delete hotlink configuration
 * @summary Delete hotlink configuration
 */
export const hotlinkconfigDelete = (hostingId, hotlinkconfigDeleteBody, options) => {
    return axios.delete(`/v1/hosting/${hostingId}/hotlinkconfig`, Object.assign({ data: hotlinkconfigDeleteBody }, options));
};
export const getHotlinkconfigDeleteMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return hotlinkconfigDelete(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Delete hotlink configuration
*/
export const useHotlinkconfigDelete = (options) => {
    const mutationOptions = getHotlinkconfigDeleteMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * List indexed files/folders
 * @summary List indexed files/folders
 */
export const listIndex = (hostingId, params, options) => {
    return axios.get(`/v1/hosting/${hostingId}/index`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getListIndexQueryKey = (hostingId, params) => {
    return [`/v1/hosting/${hostingId}/index`, ...(params ? [params] : [])];
};
export const getListIndexQueryOptions = (hostingId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getListIndexQueryKey(hostingId, params);
    const queryFn = ({ signal }) => listIndex(hostingId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary List indexed files/folders
 */
export function useListIndex(hostingId, params, options) {
    const queryOptions = getListIndexQueryOptions(hostingId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Add index to given file/folder
 * @summary Add index to file/folder
 */
export const addIndex = (hostingId, addIndexBody, options) => {
    return axios.post(`/v1/hosting/${hostingId}/index`, addIndexBody, options);
};
export const getAddIndexMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return addIndex(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Add index to file/folder
*/
export const useAddIndex = (options) => {
    const mutationOptions = getAddIndexMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Delete index to given file/folder
 * @summary Delete index to file/folder
 */
export const index = (hostingId, indexBody, options) => {
    return axios.delete(`/v1/hosting/${hostingId}/index`, Object.assign({ data: indexBody }, options));
};
export const getIndexMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return index(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Delete index to file/folder
*/
export const useIndex = (options) => {
    const mutationOptions = getIndexMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns hosting account info
 * @summary Hosting info
 */
export const hostingInfo = (hostingId, options) => {
    return axios.get(`/v1/hosting/${hostingId}/info`, options);
};
export const getHostingInfoQueryKey = (hostingId) => {
    return [`/v1/hosting/${hostingId}/info`];
};
export const getHostingInfoQueryOptions = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHostingInfoQueryKey(hostingId);
    const queryFn = ({ signal }) => hostingInfo(hostingId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary Hosting info
 */
export function useHostingInfo(hostingId, options) {
    const queryOptions = getHostingInfoQueryOptions(hostingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns the hosting account's disk usage
 * @summary info disk usage
 */
export const hostingInfoDiskUsage = (hostingId, options) => {
    return axios.get(`/v1/hosting/${hostingId}/info/diskusage`, options);
};
export const getHostingInfoDiskUsageQueryKey = (hostingId) => {
    return [`/v1/hosting/${hostingId}/info/diskusage`];
};
export const getHostingInfoDiskUsageQueryOptions = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHostingInfoDiskUsageQueryKey(hostingId);
    const queryFn = ({ signal }) => hostingInfoDiskUsage(hostingId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary info disk usage
 */
export function useHostingInfoDiskUsage(hostingId, options) {
    const queryOptions = getHostingInfoDiskUsageQueryOptions(hostingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns lead info for the user of the hosting account
 * @summary Lead info
 */
export const hostingLead = (hostingId, params, options) => {
    return axios.post(`/v1/hosting/${hostingId}/lead`, undefined, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getHostingLeadMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, params } = props !== null && props !== void 0 ? props : {};
        return hostingLead(hostingId, params, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Lead info
*/
export const useHostingLead = (options) => {
    const mutationOptions = getHostingLeadMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Gets the Wordpress migration status
 * @summary Wordpress migration status
 */
export const hostingMigrationStatus = (hostingId, options) => {
    return axios.get(`/v1/hosting/${hostingId}/migrations`, options);
};
export const getHostingMigrationStatusQueryKey = (hostingId) => {
    return [`/v1/hosting/${hostingId}/migrations`];
};
export const getHostingMigrationStatusQueryOptions = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHostingMigrationStatusQueryKey(hostingId);
    const queryFn = ({ signal }) => hostingMigrationStatus(hostingId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary Wordpress migration status
 */
export function useHostingMigrationStatus(hostingId, options) {
    const queryOptions = getHostingMigrationStatusQueryOptions(hostingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Adds the wordpressmigrate addon for a given migration id and hosting account
 * @summary start the migration process for a site
 */
export const hostingMigrations = (hostingId, hostingMigrationsBody, options) => {
    return axios.post(`/v1/hosting/${hostingId}/migrations`, hostingMigrationsBody, options);
};
export const getHostingMigrationsMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return hostingMigrations(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary start the migration process for a site
*/
export const useHostingMigrations = (options) => {
    const mutationOptions = getHostingMigrationsMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Post migration event to CWM
 * @summary hosting migrations event
 */
export const hostingMigrationsEvent = (hostingId, hostingMigrationsEventBody, options) => {
    return axios.post(`/v1/hosting/${hostingId}/migrations/event`, hostingMigrationsEventBody, options);
};
export const getHostingMigrationsEventMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return hostingMigrationsEvent(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary hosting migrations event
*/
export const useHostingMigrationsEvent = (options) => {
    const mutationOptions = getHostingMigrationsEventMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Gets the Wordpress migration information
 * @summary Wordpress migration information
 */
export const hostingMigrationInfo = (hostingId, params, options) => {
    return axios.get(`/v1/hosting/${hostingId}/migrations/info`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getHostingMigrationInfoQueryKey = (hostingId, params) => {
    return [`/v1/hosting/${hostingId}/migrations/info`, ...(params ? [params] : [])];
};
export const getHostingMigrationInfoQueryOptions = (hostingId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHostingMigrationInfoQueryKey(hostingId, params);
    const queryFn = ({ signal }) => hostingMigrationInfo(hostingId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary Wordpress migration information
 */
export function useHostingMigrationInfo(hostingId, params, options) {
    const queryOptions = getHostingMigrationInfoQueryOptions(hostingId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Provides the status of SiteMigration site_scan and deeplink to WordPress admin page
 * @summary SiteMigration site_scan status
 */
export const hostingMigrationSiteScanStatus = (hostingId, params, options) => {
    return axios.get(`/v1/hosting/${hostingId}/migrations/site-scan`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getHostingMigrationSiteScanStatusQueryKey = (hostingId, params) => {
    return [`/v1/hosting/${hostingId}/migrations/site-scan`, ...(params ? [params] : [])];
};
export const getHostingMigrationSiteScanStatusQueryOptions = (hostingId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHostingMigrationSiteScanStatusQueryKey(hostingId, params);
    const queryFn = ({ signal }) => hostingMigrationSiteScanStatus(hostingId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary SiteMigration site_scan status
 */
export function useHostingMigrationSiteScanStatus(hostingId, params, options) {
    const queryOptions = getHostingMigrationSiteScanStatusQueryOptions(hostingId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns the hosting brand nameservers
 * @deprecated
 * @summary hosting nameservers
 */
export const hostingNameservers = (hostingId, options) => {
    return axios.get(`/v1/hosting/${hostingId}/nameservers`, options);
};
export const getHostingNameserversQueryKey = (hostingId) => {
    return [`/v1/hosting/${hostingId}/nameservers`];
};
export const getHostingNameserversQueryOptions = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHostingNameserversQueryKey(hostingId);
    const queryFn = ({ signal }) => hostingNameservers(hostingId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @deprecated
 * @summary hosting nameservers
 */
export function useHostingNameservers(hostingId, options) {
    const queryOptions = getHostingNameserversQueryOptions(hostingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns onboarding data
 * @summary Returns hosting onboarding data
 */
export const hostingOnboardingData = (hostingId, options) => {
    return axios.get(`/v1/hosting/${hostingId}/onboarding`, options);
};
export const getHostingOnboardingDataQueryKey = (hostingId) => {
    return [`/v1/hosting/${hostingId}/onboarding`];
};
export const getHostingOnboardingDataQueryOptions = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHostingOnboardingDataQueryKey(hostingId);
    const queryFn = ({ signal }) => hostingOnboardingData(hostingId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary Returns hosting onboarding data
 */
export function useHostingOnboardingData(hostingId, options) {
    const queryOptions = getHostingOnboardingDataQueryOptions(hostingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * @summary Updates hosting onboarding data
 */
export const hostingOnboardingDataUpdate = (hostingId, hostingOnboardingDataUpdateBody, options) => {
    return axios.put(`/v1/hosting/${hostingId}/onboarding`, hostingOnboardingDataUpdateBody, options);
};
export const getHostingOnboardingDataUpdateMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return hostingOnboardingDataUpdate(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Updates hosting onboarding data
*/
export const useHostingOnboardingDataUpdate = (options) => {
    const mutationOptions = getHostingOnboardingDataUpdateMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Generate account password
 * @summary Generate account password
 */
export const passwordGenerate = (hostingId, options) => {
    return axios.get(`/v1/hosting/${hostingId}/password/generate`, options);
};
export const getPasswordGenerateQueryKey = (hostingId) => {
    return [`/v1/hosting/${hostingId}/password/generate`];
};
export const getPasswordGenerateQueryOptions = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getPasswordGenerateQueryKey(hostingId);
    const queryFn = ({ signal }) => passwordGenerate(hostingId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary Generate account password
 */
export function usePasswordGenerate(hostingId, options) {
    const queryOptions = getPasswordGenerateQueryOptions(hostingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Calculate account password score
 * @summary Calculate account password score
 */
export const passwordScore = (hostingId, params, options) => {
    return axios.get(`/v1/hosting/${hostingId}/password/score`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getPasswordScoreQueryKey = (hostingId, params) => {
    return [`/v1/hosting/${hostingId}/password/score`, ...(params ? [params] : [])];
};
export const getPasswordScoreQueryOptions = (hostingId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getPasswordScoreQueryKey(hostingId, params);
    const queryFn = ({ signal }) => passwordScore(hostingId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary Calculate account password score
 */
export function usePasswordScore(hostingId, params, options) {
    const queryOptions = getPasswordScoreQueryOptions(hostingId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns a list of php error logs
 * @summary To get all the php error activities log on user account associated to that domain
 */
export const phpErrors = (hostingId, params, options) => {
    return axios.get(`/v1/hosting/${hostingId}/php-errors`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getPhpErrorsQueryKey = (hostingId, params) => {
    return [`/v1/hosting/${hostingId}/php-errors`, ...(params ? [params] : [])];
};
export const getPhpErrorsQueryOptions = (hostingId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getPhpErrorsQueryKey(hostingId, params);
    const queryFn = ({ signal }) => phpErrors(hostingId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary To get all the php error activities log on user account associated to that domain
 */
export function usePhpErrors(hostingId, params, options) {
    const queryOptions = getPhpErrorsQueryOptions(hostingId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Product license details
 * @summary Product license details
 */
export const productLicenseDetails = (hostingId, params, options) => {
    return axios.get(`/v1/hosting/${hostingId}/product/license-details`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getProductLicenseDetailsQueryKey = (hostingId, params) => {
    return [`/v1/hosting/${hostingId}/product/license-details`, ...(params ? [params] : [])];
};
export const getProductLicenseDetailsQueryOptions = (hostingId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getProductLicenseDetailsQueryKey(hostingId, params);
    const queryFn = ({ signal }) => productLicenseDetails(hostingId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary Product license details
 */
export function useProductLicenseDetails(hostingId, params, options) {
    const queryOptions = getProductLicenseDetailsQueryOptions(hostingId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns the list of site's redirects
 * @summary List redirects
 */
export const hostingRedirects = (hostingId, options) => {
    return axios.get(`/v1/hosting/${hostingId}/redirects`, options);
};
export const getHostingRedirectsQueryKey = (hostingId) => {
    return [`/v1/hosting/${hostingId}/redirects`];
};
export const getHostingRedirectsQueryOptions = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHostingRedirectsQueryKey(hostingId);
    const queryFn = ({ signal }) => hostingRedirects(hostingId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary List redirects
 */
export function useHostingRedirects(hostingId, options) {
    const queryOptions = getHostingRedirectsQueryOptions(hostingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Delete the user site redirect
 * @summary Delete redirects
 */
export const hostingRedirect = (hostingId, hostingRedirectBody, options) => {
    return axios.delete(`/v1/hosting/${hostingId}/redirects`, Object.assign({ data: hostingRedirectBody }, options));
};
export const getHostingRedirectMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return hostingRedirect(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Delete redirects
*/
export const useHostingRedirect = (options) => {
    const mutationOptions = getHostingRedirectMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Add the redirect url path for the site
 * @summary Add redirects
 */
export const addHostingRedirects = (hostingId, addHostingRedirectsBody, options) => {
    return axios.post(`/v1/hosting/${hostingId}/redirects`, addHostingRedirectsBody, options);
};
export const getAddHostingRedirectsMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return addHostingRedirects(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Add redirects
*/
export const useAddHostingRedirects = (options) => {
    const mutationOptions = getAddHostingRedirectsMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns the hosting sso_whm login url
 * @summary hosting sso_whm
 */
export const hostingResellerSsoWhm = (hostingId, options) => {
    return axios.get(`/v1/hosting/${hostingId}/reseller/sso/whm`, options);
};
export const getHostingResellerSsoWhmQueryKey = (hostingId) => {
    return [`/v1/hosting/${hostingId}/reseller/sso/whm`];
};
export const getHostingResellerSsoWhmQueryOptions = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHostingResellerSsoWhmQueryKey(hostingId);
    const queryFn = ({ signal }) => hostingResellerSsoWhm(hostingId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary hosting sso_whm
 */
export function useHostingResellerSsoWhm(hostingId, options) {
    const queryOptions = getHostingResellerSsoWhmQueryOptions(hostingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns total hits and a list of hits for the last N number of days passed as input
 * @summary Hosting server hits
 */
export const hostingServerHits = (hostingId, params, options) => {
    return axios.get(`/v1/hosting/${hostingId}/server-hits`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getHostingServerHitsQueryKey = (hostingId, params) => {
    return [`/v1/hosting/${hostingId}/server-hits`, ...(params ? [params] : [])];
};
export const getHostingServerHitsQueryOptions = (hostingId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHostingServerHitsQueryKey(hostingId, params);
    const queryFn = ({ signal }) => hostingServerHits(hostingId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary Hosting server hits
 */
export function useHostingServerHits(hostingId, params, options) {
    const queryOptions = getHostingServerHitsQueryOptions(hostingId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Enable or disable shell access on an account by setting the shell.SSH key access must be established separately.
 * @summary hosting shell toggle
 */
export const hostingShellToggle = (hostingId, hostingShellToggleBody, options) => {
    return axios.put(`/v1/hosting/${hostingId}/shell`, hostingShellToggleBody, options);
};
export const getHostingShellToggleMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return hostingShellToggle(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary hosting shell toggle
*/
export const useHostingShellToggle = (options) => {
    const mutationOptions = getHostingShellToggleMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Determine shell access status for an account.
 * @summary hosting shell_status
 */
export const hostingShellInfo = (hostingId, options) => {
    return axios.get(`/v1/hosting/${hostingId}/shell`, options);
};
export const getHostingShellInfoQueryKey = (hostingId) => {
    return [`/v1/hosting/${hostingId}/shell`];
};
export const getHostingShellInfoQueryOptions = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHostingShellInfoQueryKey(hostingId);
    const queryFn = ({ signal }) => hostingShellInfo(hostingId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary hosting shell_status
 */
export function useHostingShellInfo(hostingId, options) {
    const queryOptions = getHostingShellInfoQueryOptions(hostingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Add a site to the current hosting.
 * @deprecated
 * @summary sites add
 */
export const hostingSiteAdd = (hostingId, hostingSiteAddBody, options) => {
    return axios.post(`/v1/hosting/${hostingId}/sites`, hostingSiteAddBody, options);
};
export const getHostingSiteAddMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return hostingSiteAdd(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @deprecated
* @summary sites add
*/
export const useHostingSiteAdd = (options) => {
    const mutationOptions = getHostingSiteAddMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Update Sites in batches.
 * @summary sites update batch
 */
export const sitesBatch = (hostingId, sitesBatchBody, options) => {
    return axios.put(`/v1/hosting/${hostingId}/sites/batch`, sitesBatchBody, options);
};
export const getSitesBatchMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return sitesBatch(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary sites update batch
*/
export const useSitesBatch = (options) => {
    const mutationOptions = getSitesBatchMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns the hosting account's SSH information
 * @summary ssh info
 */
export const hostingSshInfo = (hostingId, options) => {
    return axios.get(`/v1/hosting/${hostingId}/ssh`, options);
};
export const getHostingSshInfoQueryKey = (hostingId) => {
    return [`/v1/hosting/${hostingId}/ssh`];
};
export const getHostingSshInfoQueryOptions = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHostingSshInfoQueryKey(hostingId);
    const queryFn = ({ signal }) => hostingSshInfo(hostingId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary ssh info
 */
export function useHostingSshInfo(hostingId, options) {
    const queryOptions = getHostingSshInfoQueryOptions(hostingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Fetches an SSH public key.
 * @summary ssh key fetch
 */
export const sshKeyFetch = (hostingId, params, options) => {
    return axios.get(`/v1/hosting/${hostingId}/ssh/fetch`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getSshKeyFetchQueryKey = (hostingId, params) => {
    return [`/v1/hosting/${hostingId}/ssh/fetch`, ...(params ? [params] : [])];
};
export const getSshKeyFetchQueryOptions = (hostingId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSshKeyFetchQueryKey(hostingId, params);
    const queryFn = ({ signal }) => sshKeyFetch(hostingId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary ssh key fetch
 */
export function useSshKeyFetch(hostingId, params, options) {
    const queryOptions = getSshKeyFetchQueryOptions(hostingId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Import public/private ssh key
 * @deprecated
 * @summary Import ssh key
 */
export const sshKeyImport = (hostingId, sshKeyImportBody, options) => {
    return axios.post(`/v1/hosting/${hostingId}/ssh/import`, sshKeyImportBody, options);
};
export const getSshKeyImportMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return sshKeyImport(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @deprecated
* @summary Import ssh key
*/
export const useSshKeyImport = (options) => {
    const mutationOptions = getSshKeyImportMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * List all SSH keys on a server or account. Finds all keys in user's .ssh/ diretory.
 * @deprecated
 * @summary Deprecated - ssh keys list
 */
export const sshKeyList = (hostingId, options) => {
    return axios.get(`/v1/hosting/${hostingId}/ssh/keys`, options);
};
export const getSshKeyListQueryKey = (hostingId) => {
    return [`/v1/hosting/${hostingId}/ssh/keys`];
};
export const getSshKeyListQueryOptions = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSshKeyListQueryKey(hostingId);
    const queryFn = ({ signal }) => sshKeyList(hostingId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @deprecated
 * @summary Deprecated - ssh keys list
 */
export function useSshKeyList(hostingId, options) {
    const queryOptions = getSshKeyListQueryOptions(hostingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Deletes an SSH key
 * @deprecated
 * @summary ssh key delete
 */
export const sshKey = (hostingId, sshKeyBody, options) => {
    return axios.delete(`/v1/hosting/${hostingId}/ssh/keys`, Object.assign({ data: sshKeyBody }, options));
};
export const getSshKeyMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return sshKey(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @deprecated
* @summary ssh key delete
*/
export const useSshKey = (options) => {
    const mutationOptions = getSshKeyMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Generates public/private ssh keys
 * @summary Generate ssh key
 */
export const sshKeyGenerate = (hostingId, sshKeyGenerateBody, options) => {
    return axios.post(`/v1/hosting/${hostingId}/ssh/keys`, sshKeyGenerateBody, options);
};
export const getSshKeyGenerateMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return sshKeyGenerate(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Generate ssh key
*/
export const useSshKeyGenerate = (options) => {
    const mutationOptions = getSshKeyGenerateMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns a SSO login token for a hosting account by default, or directly to various apps within the hosting account by using the optional query parameter.
 * @summary sso
 */
export const sso = (hostingId, params, options) => {
    return axios.get(`/v1/hosting/${hostingId}/sso`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getSsoQueryKey = (hostingId, params) => {
    return [`/v1/hosting/${hostingId}/sso`, ...(params ? [params] : [])];
};
export const getSsoQueryOptions = (hostingId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSsoQueryKey(hostingId, params);
    const queryFn = ({ signal }) => sso(hostingId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary sso
 */
export function useSso(hostingId, params, options) {
    const queryOptions = getSsoQueryOptions(hostingId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns site x axis for graphical representation
 * @summary domain visitors
 */
export const hostingVisitors = (hostingId, params, options) => {
    return axios.get(`/v1/hosting/${hostingId}/visitors`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getHostingVisitorsQueryKey = (hostingId, params) => {
    return [`/v1/hosting/${hostingId}/visitors`, ...(params ? [params] : [])];
};
export const getHostingVisitorsQueryOptions = (hostingId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHostingVisitorsQueryKey(hostingId, params);
    const queryFn = ({ signal }) => hostingVisitors(hostingId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary domain visitors
 */
export function useHostingVisitors(hostingId, params, options) {
    const queryOptions = getHostingVisitorsQueryOptions(hostingId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns site information.
 * @summary info
 */
export const sitesInfo = (siteId, options) => {
    return axios.get(`/v1/sites/${siteId}`, options);
};
export const getSitesInfoQueryKey = (siteId) => {
    return [`/v1/sites/${siteId}`];
};
export const getSitesInfoQueryOptions = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesInfoQueryKey(siteId);
    const queryFn = ({ signal }) => sitesInfo(siteId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary info
 */
export function useSitesInfo(siteId, options) {
    const queryOptions = getSitesInfoQueryOptions(siteId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Allows for updating a site's attributes
 * @summary site update
 */
export const siteUpdate = (siteId, siteUpdateBody, options) => {
    return axios.put(`/v1/sites/${siteId}`, siteUpdateBody, options);
};
export const getSiteUpdateMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return siteUpdate(siteId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary site update
*/
export const useSiteUpdate = (options) => {
    const mutationOptions = getSiteUpdateMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Allows deleting a site
 * @summary site delete
 */
export const site = (siteId, siteBody, options) => {
    return axios.delete(`/v1/sites/${siteId}`, Object.assign({ data: siteBody }, options));
};
export const getSiteMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return site(siteId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary site delete
*/
export const useSite = (options) => {
    const mutationOptions = getSiteMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns raw periods data or day-wise summarized hits for a given site based on metric/dimension.
 * @summary Fetch atomic site metrics (raw or daywise)
 */
export const sitesAtomicMetrics = (siteId, params, options) => {
    return axios.get(`/v1/sites/${siteId}/atomic/metrics`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getSitesAtomicMetricsQueryKey = (siteId, params) => {
    return [`/v1/sites/${siteId}/atomic/metrics`, ...(params ? [params] : [])];
};
export const getSitesAtomicMetricsQueryOptions = (siteId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesAtomicMetricsQueryKey(siteId, params);
    const queryFn = ({ signal }) => sitesAtomicMetrics(siteId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary Fetch atomic site metrics (raw or daywise)
 */
export function useSitesAtomicMetrics(siteId, params, options) {
    const queryOptions = getSitesAtomicMetricsQueryOptions(siteId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns the autoupdate status of the site's core, themes, and plugins
 * @summary settings autoupdates
 */
export const sitesAutoupdatesInfo = (siteId, options) => {
    return axios.get(`/v1/sites/${siteId}/autoupdates`, options);
};
export const getSitesAutoupdatesInfoQueryKey = (siteId) => {
    return [`/v1/sites/${siteId}/autoupdates`];
};
export const getSitesAutoupdatesInfoQueryOptions = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesAutoupdatesInfoQueryKey(siteId);
    const queryFn = ({ signal }) => sitesAutoupdatesInfo(siteId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary settings autoupdates
 */
export function useSitesAutoupdatesInfo(siteId, options) {
    const queryOptions = getSitesAutoupdatesInfoQueryOptions(siteId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Enable / disable core, themes, or plugins autoupdates
 * @summary settings autoupdates toggle
 */
export const sitesAutoupdatesUpdate = (siteId, sitesAutoupdatesUpdateBody, options) => {
    return axios.put(`/v1/sites/${siteId}/autoupdates`, sitesAutoupdatesUpdateBody, options);
};
export const getSitesAutoupdatesUpdateMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return sitesAutoupdatesUpdate(siteId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary settings autoupdates toggle
*/
export const useSitesAutoupdatesUpdate = (options) => {
    const mutationOptions = getSitesAutoupdatesUpdateMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns whether the site has either Codeguard or Jetpack-backup.
 * @deprecated
 * @summary Deprecated - has backup
 */
export const sitesBackups = (siteId, options) => {
    return axios.get(`/v1/sites/${siteId}/backups`, options);
};
export const getSitesBackupsQueryKey = (siteId) => {
    return [`/v1/sites/${siteId}/backups`];
};
export const getSitesBackupsQueryOptions = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesBackupsQueryKey(siteId);
    const queryFn = ({ signal }) => sitesBackups(siteId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @deprecated
 * @summary Deprecated - has backup
 */
export function useSitesBackups(siteId, options) {
    const queryOptions = getSitesBackupsQueryOptions(siteId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns whether the site has either Codeguard or Jetpack-backup.
 * @summary has backups
 */
export const sitesHasBackups = (siteId, options) => {
    return axios.get(`/v1/sites/${siteId}/backups/check`, options);
};
export const getSitesHasBackupsQueryKey = (siteId) => {
    return [`/v1/sites/${siteId}/backups/check`];
};
export const getSitesHasBackupsQueryOptions = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesHasBackupsQueryKey(siteId);
    const queryFn = ({ signal }) => sitesHasBackups(siteId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary has backups
 */
export function useSitesHasBackups(siteId, options) {
    const queryOptions = getSitesHasBackupsQueryOptions(siteId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Adds the site to the codeguard
 * @summary Add additional sites to codeguard
 */
export const sitesBackupsCodeguard = (siteId, options) => {
    return axios.post(`/v1/sites/${siteId}/backups/codeguard`, undefined, options);
};
export const getSitesBackupsCodeguardMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId } = props !== null && props !== void 0 ? props : {};
        return sitesBackupsCodeguard(siteId, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Add additional sites to codeguard
*/
export const useSitesBackupsCodeguard = (options) => {
    const mutationOptions = getSitesBackupsCodeguardMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns details about the backup options available for the site, i.e. details about the codeguard backup addon and the jetpack based on if one or both of them are added to the account.
 * @summary site backup details
 */
export const sitesBackupsDetails = (siteId, options) => {
    return axios.get(`/v1/sites/${siteId}/backups/details`, options);
};
export const getSitesBackupsDetailsQueryKey = (siteId) => {
    return [`/v1/sites/${siteId}/backups/details`];
};
export const getSitesBackupsDetailsQueryOptions = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesBackupsDetailsQueryKey(siteId);
    const queryFn = ({ signal }) => sitesBackupsDetails(siteId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary site backup details
 */
export function useSitesBackupsDetails(siteId, options) {
    const queryOptions = getSitesBackupsDetailsQueryOptions(siteId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * The products supported jetpack-backup addon and jetpack-backup plugin
 * @summary Returns the status of the jetpack-backup product
 */
export const jetpackBackupStatus = (siteId, options) => {
    return axios.get(`/v1/sites/${siteId}/backups/jetpack`, options);
};
export const getJetpackBackupStatusQueryKey = (siteId) => {
    return [`/v1/sites/${siteId}/backups/jetpack`];
};
export const getJetpackBackupStatusQueryOptions = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getJetpackBackupStatusQueryKey(siteId);
    const queryFn = ({ signal }) => jetpackBackupStatus(siteId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary Returns the status of the jetpack-backup product
 */
export function useJetpackBackupStatus(siteId, options) {
    const queryOptions = getJetpackBackupStatusQueryOptions(siteId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Toggles the pending_upgrade meta of the provided jetpackbackup HAL addon
 * @summary Toggles the pending_upgrade meta of the provided jetpackbackup HAL addon
 */
export const backupsJetpackBackup = (siteId, options) => {
    return axios.put(`/v1/sites/${siteId}/backups/jetpack`, undefined, options);
};
export const getBackupsJetpackBackupMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId } = props !== null && props !== void 0 ? props : {};
        return backupsJetpackBackup(siteId, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Toggles the pending_upgrade meta of the provided jetpackbackup HAL addon
*/
export const useBackupsJetpackBackup = (options) => {
    const mutationOptions = getBackupsJetpackBackupMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Creates cloudflare basic addon using site_id
 * @summary Install cloudflare basic addon using site_id
 */
export const siteAddonCloudflare = (siteId, options) => {
    return axios.post(`/v1/sites/${siteId}/cloudflare`, undefined, options);
};
export const getSiteAddonCloudflareMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId } = props !== null && props !== void 0 ? props : {};
        return siteAddonCloudflare(siteId, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Install cloudflare basic addon using site_id
*/
export const useSiteAddonCloudflare = (options) => {
    const mutationOptions = getSiteAddonCloudflareMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Get info about site database
 * @summary site - database info
 */
export const sitesDatabaseInfo = (siteId, options) => {
    return axios.get(`/v1/sites/${siteId}/database`, options);
};
export const getSitesDatabaseInfoQueryKey = (siteId) => {
    return [`/v1/sites/${siteId}/database`];
};
export const getSitesDatabaseInfoQueryOptions = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesDatabaseInfoQueryKey(siteId);
    const queryFn = ({ signal }) => sitesDatabaseInfo(siteId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary site - database info
 */
export function useSitesDatabaseInfo(siteId, options) {
    const queryOptions = getSitesDatabaseInfoQueryOptions(siteId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Resync database password with whats in wp-config
 * @summary site - database - password sync
 */
export const sitesDatabasePasswordsync = (siteId, options) => {
    return axios.post(`/v1/sites/${siteId}/database/password-sync`, undefined, options);
};
export const getSitesDatabasePasswordsyncMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId } = props !== null && props !== void 0 ? props : {};
        return sitesDatabasePasswordsync(siteId, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary site - database - password sync
*/
export const useSitesDatabasePasswordsync = (options) => {
    const mutationOptions = getSitesDatabasePasswordsyncMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns a list of DNS records for the site's domain.
 * @summary dns
 */
export const sitesDns = (siteId, params, options) => {
    return axios.get(`/v1/sites/${siteId}/dns`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getSitesDnsQueryKey = (siteId, params) => {
    return [`/v1/sites/${siteId}/dns`, ...(params ? [params] : [])];
};
export const getSitesDnsQueryOptions = (siteId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesDnsQueryKey(siteId, params);
    const queryFn = ({ signal }) => sitesDns(siteId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary dns
 */
export function useSitesDns(siteId, params, options) {
    const queryOptions = getSitesDnsQueryOptions(siteId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Determines if the domain has the correct DNS setup for site
 * @summary Get DNS connection info for a site and given domain
 */
export const sitesDomain = (siteId, params, options) => {
    return axios.get(`/v1/sites/${siteId}/domain`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getSitesDomainQueryKey = (siteId, params) => {
    return [`/v1/sites/${siteId}/domain`, ...(params ? [params] : [])];
};
export const getSitesDomainQueryOptions = (siteId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesDomainQueryKey(siteId, params);
    const queryFn = ({ signal }) => sitesDomain(siteId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary Get DNS connection info for a site and given domain
 */
export function useSitesDomain(siteId, params, options) {
    const queryOptions = getSitesDomainQueryOptions(siteId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Add or promote pending site url
 * @summary Add pending site url
 */
export const sitesDomainUrl = (siteId, sitesDomainUrlBody, options) => {
    return axios.post(`/v1/sites/${siteId}/domain`, sitesDomainUrlBody, options);
};
export const getSitesDomainUrlMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return sitesDomainUrl(siteId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Add pending site url
*/
export const useSitesDomainUrl = (options) => {
    const mutationOptions = getSitesDomainUrlMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Add the domain
 * @summary Add domain for the site
 */
export const sitesDomainsCreate = (siteId, sitesDomainsCreateBody, options) => {
    return axios.post(`/v1/sites/${siteId}/domains`, sitesDomainsCreateBody, options);
};
export const getSitesDomainsCreateMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return sitesDomainsCreate(siteId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Add domain for the site
*/
export const useSitesDomainsCreate = (options) => {
    const mutationOptions = getSitesDomainsCreateMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Get error pages
 * @summary Get error pages
 */
export const errorPagesFetch = (siteId, params, options) => {
    return axios.get(`/v1/sites/${siteId}/error-pages`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getErrorPagesFetchQueryKey = (siteId, params) => {
    return [`/v1/sites/${siteId}/error-pages`, ...(params ? [params] : [])];
};
export const getErrorPagesFetchQueryOptions = (siteId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getErrorPagesFetchQueryKey(siteId, params);
    const queryFn = ({ signal }) => errorPagesFetch(siteId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary Get error pages
 */
export function useErrorPagesFetch(siteId, params, options) {
    const queryOptions = getErrorPagesFetchQueryOptions(siteId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Add error pages
 * @summary Add error pages
 */
export const errorPagesAdd = (siteId, errorPagesAddBody, options) => {
    return axios.post(`/v1/sites/${siteId}/error-pages`, errorPagesAddBody, options);
};
export const getErrorPagesAddMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return errorPagesAdd(siteId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Add error pages
*/
export const useErrorPagesAdd = (options) => {
    const mutationOptions = getErrorPagesAddMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Delete error pages
 * @summary Delete error pages
 */
export const errorPagesDelete = (siteId, errorPagesDeleteBody, options) => {
    return axios.delete(`/v1/sites/${siteId}/error-pages`, Object.assign({ data: errorPagesDeleteBody }, options));
};
export const getErrorPagesDeleteMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return errorPagesDelete(siteId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Delete error pages
*/
export const useErrorPagesDelete = (options) => {
    const mutationOptions = getErrorPagesDeleteMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns the list of  blocked ipaddress
 * @summary List blocked IPAddress
 */
export const siteIpaddressList = (siteId, options) => {
    return axios.get(`/v1/sites/${siteId}/ipblocker`, options);
};
export const getSiteIpaddressListQueryKey = (siteId) => {
    return [`/v1/sites/${siteId}/ipblocker`];
};
export const getSiteIpaddressListQueryOptions = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSiteIpaddressListQueryKey(siteId);
    const queryFn = ({ signal }) => siteIpaddressList(siteId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary List blocked IPAddress
 */
export function useSiteIpaddressList(siteId, options) {
    const queryOptions = getSiteIpaddressListQueryOptions(siteId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Delete the user site ipaddress
 * @summary Delete ipAddress
 */
export const siteIpaddress = (siteId, siteIpaddressBody, options) => {
    return axios.delete(`/v1/sites/${siteId}/ipblocker`, Object.assign({ data: siteIpaddressBody }, options));
};
export const getSiteIpaddressMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return siteIpaddress(siteId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Delete ipAddress
*/
export const useSiteIpaddress = (options) => {
    const mutationOptions = getSiteIpaddressMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Add the ipaddress url for the site
 * @summary Add blocked ipaddress
 */
export const addSiteIpaddress = (siteId, addSiteIpaddressBody, options) => {
    return axios.post(`/v1/sites/${siteId}/ipblocker`, addSiteIpaddressBody, options);
};
export const getAddSiteIpaddressMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return addSiteIpaddress(siteId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Add blocked ipaddress
*/
export const useAddSiteIpaddress = (options) => {
    const mutationOptions = getAddSiteIpaddressMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns site access logs.
 * @summary Site access logs
 */
export const sitesAccessLogs = (siteId, params, options) => {
    return axios.get(`/v1/sites/${siteId}/logs/access`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getSitesAccessLogsQueryKey = (siteId, params) => {
    return [`/v1/sites/${siteId}/logs/access`, ...(params ? [params] : [])];
};
export const getSitesAccessLogsInfiniteQueryOptions = (siteId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesAccessLogsQueryKey(siteId, params);
    const queryFn = ({ signal, pageParam }) => sitesAccessLogs(siteId, Object.assign(Object.assign({}, params), { page_id: pageParam || (params === null || params === void 0 ? void 0 : params['page_id']) }), Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary Site access logs
 */
export function useSitesAccessLogsInfinite(siteId, params, options) {
    const queryOptions = getSitesAccessLogsInfiniteQueryOptions(siteId, params, options);
    const query = useInfiniteQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getSitesAccessLogsQueryOptions = (siteId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesAccessLogsQueryKey(siteId, params);
    const queryFn = ({ signal }) => sitesAccessLogs(siteId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary Site access logs
 */
export function useSitesAccessLogs(siteId, params, options) {
    const queryOptions = getSitesAccessLogsQueryOptions(siteId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns site access logs.
 * @summary Site access logs
 */
export const sitesAccessLogsDownload = (siteId, params, options) => {
    return axios.get(`/v1/sites/${siteId}/logs/access/download`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getSitesAccessLogsDownloadQueryKey = (siteId, params) => {
    return [`/v1/sites/${siteId}/logs/access/download`, ...(params ? [params] : [])];
};
export const getSitesAccessLogsDownloadQueryOptions = (siteId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesAccessLogsDownloadQueryKey(siteId, params);
    const queryFn = ({ signal }) => sitesAccessLogsDownload(siteId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary Site access logs
 */
export function useSitesAccessLogsDownload(siteId, params, options) {
    const queryOptions = getSitesAccessLogsDownloadQueryOptions(siteId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns site error logs.
 * @summary Site error logs
 */
export const sitesErrorLogs = (siteId, params, options) => {
    return axios.get(`/v1/sites/${siteId}/logs/error`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getSitesErrorLogsQueryKey = (siteId, params) => {
    return [`/v1/sites/${siteId}/logs/error`, ...(params ? [params] : [])];
};
export const getSitesErrorLogsInfiniteQueryOptions = (siteId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesErrorLogsQueryKey(siteId, params);
    const queryFn = ({ signal, pageParam }) => sitesErrorLogs(siteId, Object.assign(Object.assign({}, params), { page_id: pageParam || (params === null || params === void 0 ? void 0 : params['page_id']) }), Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary Site error logs
 */
export function useSitesErrorLogsInfinite(siteId, params, options) {
    const queryOptions = getSitesErrorLogsInfiniteQueryOptions(siteId, params, options);
    const query = useInfiniteQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getSitesErrorLogsQueryOptions = (siteId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesErrorLogsQueryKey(siteId, params);
    const queryFn = ({ signal }) => sitesErrorLogs(siteId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary Site error logs
 */
export function useSitesErrorLogs(siteId, params, options) {
    const queryOptions = getSitesErrorLogsQueryOptions(siteId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns site error logs.
 * @summary Site error logs
 */
export const sitesErrorLogsDownload = (siteId, params, options) => {
    return axios.get(`/v1/sites/${siteId}/logs/error/download`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getSitesErrorLogsDownloadQueryKey = (siteId, params) => {
    return [`/v1/sites/${siteId}/logs/error/download`, ...(params ? [params] : [])];
};
export const getSitesErrorLogsDownloadQueryOptions = (siteId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesErrorLogsDownloadQueryKey(siteId, params);
    const queryFn = ({ signal }) => sitesErrorLogsDownload(siteId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary Site error logs
 */
export function useSitesErrorLogsDownload(siteId, params, options) {
    const queryOptions = getSitesErrorLogsDownloadQueryOptions(siteId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns malware status of atomic site
 * @summary malware status of atomic site
 */
export const siteMalwareStatus = (siteId, options) => {
    return axios.get(`/v1/sites/${siteId}/malware-status`, options);
};
export const getSiteMalwareStatusQueryKey = (siteId) => {
    return [`/v1/sites/${siteId}/malware-status`];
};
export const getSiteMalwareStatusQueryOptions = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSiteMalwareStatusQueryKey(siteId);
    const queryFn = ({ signal }) => siteMalwareStatus(siteId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary malware status of atomic site
 */
export function useSiteMalwareStatus(siteId, options) {
    const queryOptions = getSiteMalwareStatusQueryOptions(siteId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns site metrics summary
 * @summary metrics
 */
export const sitesMetricsDimensionAveraged = (siteId, params, dimension = 'http_host', options) => {
    return axios.get(`/v1/sites/${siteId}/metrics/dimension/${dimension}/averaged`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getSitesMetricsDimensionAveragedQueryKey = (siteId, params, dimension = 'http_host') => {
    return [`/v1/sites/${siteId}/metrics/dimension/${dimension}/averaged`, ...(params ? [params] : [])];
};
export const getSitesMetricsDimensionAveragedQueryOptions = (siteId, params, dimension = 'http_host', options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesMetricsDimensionAveragedQueryKey(siteId, params, dimension);
    const queryFn = ({ signal }) => sitesMetricsDimensionAveraged(siteId, params, dimension, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId && dimension) }, queryOptions);
};
/**
 * @summary metrics
 */
export function useSitesMetricsDimensionAveraged(siteId, params, dimension = 'http_host', options) {
    const queryOptions = getSitesMetricsDimensionAveragedQueryOptions(siteId, params, dimension, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns site metrics.
 * @summary metrics
 */
export const sitesMetricDimensions = (siteId, metric, params, options) => {
    return axios.get(`/v1/sites/${siteId}/metrics/${metric}/dimensions`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getSitesMetricDimensionsQueryKey = (siteId, metric, params) => {
    return [`/v1/sites/${siteId}/metrics/${metric}/dimensions`, ...(params ? [params] : [])];
};
export const getSitesMetricDimensionsQueryOptions = (siteId, metric, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesMetricDimensionsQueryKey(siteId, metric, params);
    const queryFn = ({ signal }) => sitesMetricDimensions(siteId, metric, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId && metric) }, queryOptions);
};
/**
 * @summary metrics
 */
export function useSitesMetricDimensions(siteId, metric, params, options) {
    const queryOptions = getSitesMetricDimensionsQueryOptions(siteId, metric, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Delete pending domain
 * @summary Delete pending domain
 */
export const sitePendingDomainDelete = (siteId, options) => {
    return axios.delete(`/v1/sites/${siteId}/pending-domain`, options);
};
export const getSitePendingDomainDeleteMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId } = props !== null && props !== void 0 ? props : {};
        return sitePendingDomainDelete(siteId, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Delete pending domain
*/
export const useSitePendingDomainDelete = (options) => {
    const mutationOptions = getSitePendingDomainDeleteMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * cache purge site and url
 * @summary cache purge url
 */
export const sitesPerformanceCachepurge = (siteId, sitesPerformanceCachepurgeBody, options) => {
    return axios.post(`/v1/sites/${siteId}/performance/cachepurge`, sitesPerformanceCachepurgeBody, options);
};
export const getSitesPerformanceCachepurgeMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return sitesPerformanceCachepurge(siteId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary cache purge url
*/
export const useSitesPerformanceCachepurge = (options) => {
    const mutationOptions = getSitesPerformanceCachepurgeMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Update the edge cache
 * @summary edge cache toggle for atomic site
 */
export const sitesPerformanceEdgecache = (siteId, sitesPerformanceEdgecacheBody, options) => {
    return axios.put(`/v1/sites/${siteId}/performance/edge_cache`, sitesPerformanceEdgecacheBody, options);
};
export const getSitesPerformanceEdgecacheMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return sitesPerformanceEdgecache(siteId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary edge cache toggle for atomic site
*/
export const useSitesPerformanceEdgecache = (options) => {
    const mutationOptions = getSitesPerformanceEdgecacheMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns the status of endurance_cache_level
 * @summary Get status of endurance cache level
 */
export const sitesPerformanceEnduranceCacheLevelStatus = (siteId, options) => {
    return axios.get(`/v1/sites/${siteId}/performance/endurance_cache_level`, options);
};
export const getSitesPerformanceEnduranceCacheLevelStatusQueryKey = (siteId) => {
    return [`/v1/sites/${siteId}/performance/endurance_cache_level`];
};
export const getSitesPerformanceEnduranceCacheLevelStatusQueryOptions = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesPerformanceEnduranceCacheLevelStatusQueryKey(siteId);
    const queryFn = ({ signal }) => sitesPerformanceEnduranceCacheLevelStatus(siteId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary Get status of endurance cache level
 */
export function useSitesPerformanceEnduranceCacheLevelStatus(siteId, options) {
    const queryOptions = getSitesPerformanceEnduranceCacheLevelStatusQueryOptions(siteId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Set endurance cache level to 0, 1,2 or 3
 * @summary Set endurance cache level
 */
export const sitesPerformanceEnduranceCacheLevel = (siteId, sitesPerformanceEnduranceCacheLevelBody, options) => {
    return axios.post(`/v1/sites/${siteId}/performance/endurance_cache_level`, sitesPerformanceEnduranceCacheLevelBody, options);
};
export const getSitesPerformanceEnduranceCacheLevelMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return sitesPerformanceEnduranceCacheLevel(siteId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Set endurance cache level
*/
export const useSitesPerformanceEnduranceCacheLevel = (options) => {
    const mutationOptions = getSitesPerformanceEnduranceCacheLevelMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Update the endurance page cache
 * @summary update the endurance cache page
 */
export const sitesPerformanceEndurancePageCache = (siteId, options) => {
    return axios.put(`/v1/sites/${siteId}/performance/endurance_page_cache`, undefined, options);
};
export const getSitesPerformanceEndurancePageCacheMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId } = props !== null && props !== void 0 ? props : {};
        return sitesPerformanceEndurancePageCache(siteId, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary update the endurance cache page
*/
export const useSitesPerformanceEndurancePageCache = (options) => {
    const mutationOptions = getSitesPerformanceEndurancePageCacheMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Create php info for a site
 * @summary Create php info for a site
 */
export const createPhpInfo = (siteId, options) => {
    return axios.post(`/v1/sites/${siteId}/php-info`, undefined, options);
};
export const getCreatePhpInfoMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId } = props !== null && props !== void 0 ? props : {};
        return createPhpInfo(siteId, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Create php info for a site
*/
export const useCreatePhpInfo = (options) => {
    const mutationOptions = getCreatePhpInfoMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns a list of the site's plugins
 * @summary plugins
 */
export const sitePlugins = (siteId, params, options) => {
    return axios.get(`/v1/sites/${siteId}/plugins`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getSitePluginsQueryKey = (siteId, params) => {
    return [`/v1/sites/${siteId}/plugins`, ...(params ? [params] : [])];
};
export const getSitePluginsQueryOptions = (siteId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitePluginsQueryKey(siteId, params);
    const queryFn = ({ signal }) => sitePlugins(siteId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary plugins
 */
export function useSitePlugins(siteId, params, options) {
    const queryOptions = getSitePluginsQueryOptions(siteId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Enables / disables a plugin
 * @summary plugins toggle
 */
export const sitePluginUpdate = (siteId, sitePluginUpdateBody, options) => {
    return axios.put(`/v1/sites/${siteId}/plugins`, sitePluginUpdateBody, options);
};
export const getSitePluginUpdateMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return sitePluginUpdate(siteId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary plugins toggle
*/
export const useSitePluginUpdate = (options) => {
    const mutationOptions = getSitePluginUpdateMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Enables / disables plugin auto-updates
 * @deprecated
 * @summary plugins autoupdate
 */
export const sitePluginsAutoupdate = (siteId, sitePluginsAutoupdateBody, options) => {
    return axios.post(`/v1/sites/${siteId}/plugins/autoupdate`, sitePluginsAutoupdateBody, options);
};
export const getSitePluginsAutoupdateMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return sitePluginsAutoupdate(siteId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @deprecated
* @summary plugins autoupdate
*/
export const useSitePluginsAutoupdate = (options) => {
    const mutationOptions = getSitePluginsAutoupdateMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Enables / disables a plugin
 * @deprecated
 * @summary Deprecated - plugins toggle
 */
export const sitePluginsToggle = (siteId, sitePluginsToggleBody, options) => {
    return axios.post(`/v1/sites/${siteId}/plugins/toggle`, sitePluginsToggleBody, options);
};
export const getSitePluginsToggleMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return sitePluginsToggle(siteId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @deprecated
* @summary Deprecated - plugins toggle
*/
export const useSitePluginsToggle = (options) => {
    const mutationOptions = getSitePluginsToggleMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Updates a plugin
 * @summary plugins update
 */
export const sitePluginsUpdate = (siteId, sitePluginsUpdateBody, options) => {
    return axios.post(`/v1/sites/${siteId}/plugins/update`, sitePluginsUpdateBody, options);
};
export const getSitePluginsUpdateMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return sitePluginsUpdate(siteId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary plugins update
*/
export const useSitePluginsUpdate = (options) => {
    const mutationOptions = getSitePluginsUpdateMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns metric for a site url from pagespeed
 * @summary get pagespeed index api data for a site
 */
export const siteQualityMetrics = (siteId, params, options) => {
    return axios.get(`/v1/sites/${siteId}/quality-metrics`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getSiteQualityMetricsQueryKey = (siteId, params) => {
    return [`/v1/sites/${siteId}/quality-metrics`, ...(params ? [params] : [])];
};
export const getSiteQualityMetricsQueryOptions = (siteId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSiteQualityMetricsQueryKey(siteId, params);
    const queryFn = ({ signal }) => siteQualityMetrics(siteId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary get pagespeed index api data for a site
 */
export function useSiteQualityMetrics(siteId, params, options) {
    const queryOptions = getSiteQualityMetricsQueryOptions(siteId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Resets a site - deletes/reinstalls the site.
 * @summary reset site
 */
export const resetSite = (siteId, resetSiteBody, options) => {
    return axios.post(`/v1/sites/${siteId}/reset`, resetSiteBody, options);
};
export const getResetSiteMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return resetSite(siteId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary reset site
*/
export const useResetSite = (options) => {
    const mutationOptions = getResetSiteMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * if security bundle to be enabled.
 * @summary security bundle
 */
export const sitesSecurityBundle = (siteId, options) => {
    return axios.get(`/v1/sites/${siteId}/security/bundle`, options);
};
export const getSitesSecurityBundleQueryKey = (siteId) => {
    return [`/v1/sites/${siteId}/security/bundle`];
};
export const getSitesSecurityBundleQueryOptions = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesSecurityBundleQueryKey(siteId);
    const queryFn = ({ signal }) => sitesSecurityBundle(siteId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary security bundle
 */
export function useSitesSecurityBundle(siteId, options) {
    const queryOptions = getSitesSecurityBundleQueryOptions(siteId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Performs a checksum of the site's core files to verify integrity.
 * @summary core files checksum
 */
export const sitesSecurityCheckCore = (siteId, options) => {
    return axios.get(`/v1/sites/${siteId}/security/core/check`, options);
};
export const getSitesSecurityCheckCoreQueryKey = (siteId) => {
    return [`/v1/sites/${siteId}/security/core/check`];
};
export const getSitesSecurityCheckCoreQueryOptions = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesSecurityCheckCoreQueryKey(siteId);
    const queryFn = ({ signal }) => sitesSecurityCheckCore(siteId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary core files checksum
 */
export function useSitesSecurityCheckCore(siteId, options) {
    const queryOptions = getSitesSecurityCheckCoreQueryOptions(siteId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Resets the site's core files.
 * @summary core files reset
 */
export const sitesSecurityResetCoreFiles = (siteId, options) => {
    return axios.post(`/v1/sites/${siteId}/security/core/reset`, undefined, options);
};
export const getSitesSecurityResetCoreFilesMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId } = props !== null && props !== void 0 ? props : {};
        return sitesSecurityResetCoreFiles(siteId, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary core files reset
*/
export const useSitesSecurityResetCoreFiles = (options) => {
    const mutationOptions = getSitesSecurityResetCoreFilesMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns the HTTPS redirection status.
 * @summary https redirection status
 */
export const sitesSecurityHttpsRedirectionStatus = (siteId, options) => {
    return axios.get(`/v1/sites/${siteId}/security/https`, options);
};
export const getSitesSecurityHttpsRedirectionStatusQueryKey = (siteId) => {
    return [`/v1/sites/${siteId}/security/https`];
};
export const getSitesSecurityHttpsRedirectionStatusQueryOptions = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesSecurityHttpsRedirectionStatusQueryKey(siteId);
    const queryFn = ({ signal }) => sitesSecurityHttpsRedirectionStatus(siteId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary https redirection status
 */
export function useSitesSecurityHttpsRedirectionStatus(siteId, options) {
    const queryOptions = getSitesSecurityHttpsRedirectionStatusQueryOptions(siteId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Enables / disables HTTPS redirection.
 * @summary https redirection toggle
 */
export const sitesSecurityHttpsEnableDisableSsl = (siteId, sitesSecurityHttpsEnableDisableSslBody, options) => {
    return axios.post(`/v1/sites/${siteId}/security/https`, sitesSecurityHttpsEnableDisableSslBody, options);
};
export const getSitesSecurityHttpsEnableDisableSslMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return sitesSecurityHttpsEnableDisableSsl(siteId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary https redirection toggle
*/
export const useSitesSecurityHttpsEnableDisableSsl = (options) => {
    const mutationOptions = getSitesSecurityHttpsEnableDisableSslMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns the site's sitelock information.
 * @summary sitelock info
 */
export const sitesSecuritySitelock = (siteId, params, options) => {
    return axios.get(`/v1/sites/${siteId}/security/sitelock`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getSitesSecuritySitelockQueryKey = (siteId, params) => {
    return [`/v1/sites/${siteId}/security/sitelock`, ...(params ? [params] : [])];
};
export const getSitesSecuritySitelockQueryOptions = (siteId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesSecuritySitelockQueryKey(siteId, params);
    const queryFn = ({ signal }) => sitesSecuritySitelock(siteId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary sitelock info
 */
export function useSitesSecuritySitelock(siteId, params, options) {
    const queryOptions = getSitesSecuritySitelockQueryOptions(siteId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Disables / enables cPanel to generate Let's Encrypt SSLs for the site.
 * @summary ssl lets encrypt toggle
 */
export const sitesSecuritySslAcme = (siteId, options) => {
    return axios.post(`/v1/sites/${siteId}/security/ssl/acme`, undefined, options);
};
export const getSitesSecuritySslAcmeMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId } = props !== null && props !== void 0 ? props : {};
        return sitesSecuritySslAcme(siteId, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary ssl lets encrypt toggle
*/
export const useSitesSecuritySslAcme = (options) => {
    const mutationOptions = getSitesSecuritySslAcmeMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns the site's SSL Status
 * @deprecated
 * @summary ssl status
 */
export const sitesSecuritySslStatus = (siteId, params, options) => {
    return axios.get(`/v1/sites/${siteId}/security/ssl/status`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getSitesSecuritySslStatusQueryKey = (siteId, params) => {
    return [`/v1/sites/${siteId}/security/ssl/status`, ...(params ? [params] : [])];
};
export const getSitesSecuritySslStatusQueryOptions = (siteId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesSecuritySslStatusQueryKey(siteId, params);
    const queryFn = ({ signal }) => sitesSecuritySslStatus(siteId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @deprecated
 * @summary ssl status
 */
export function useSitesSecuritySslStatus(siteId, params, options) {
    const queryOptions = getSitesSecuritySslStatusQueryOptions(siteId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns whether the coming soon setting is enable or disabled
 * @summary settings coming soon page status
 */
export const sitesSettingsComingSoon = (siteId, options) => {
    return axios.get(`/v1/sites/${siteId}/settings/coming-soon`, options);
};
export const getSitesSettingsComingSoonQueryKey = (siteId) => {
    return [`/v1/sites/${siteId}/settings/coming-soon`];
};
export const getSitesSettingsComingSoonQueryOptions = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesSettingsComingSoonQueryKey(siteId);
    const queryFn = ({ signal }) => sitesSettingsComingSoon(siteId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary settings coming soon page status
 */
export function useSitesSettingsComingSoon(siteId, options) {
    const queryOptions = getSitesSettingsComingSoonQueryOptions(siteId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Enables/disables the coming soon (under-construction) page
 * @summary settings coming soon toggle
 */
export const sitesSettingsComingSoonToggle = (siteId, sitesSettingsComingSoonToggleBody, options) => {
    return axios.post(`/v1/sites/${siteId}/settings/coming-soon`, sitesSettingsComingSoonToggleBody, options);
};
export const getSitesSettingsComingSoonToggleMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return sitesSettingsComingSoonToggle(siteId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary settings coming soon toggle
*/
export const useSitesSettingsComingSoonToggle = (options) => {
    const mutationOptions = getSitesSettingsComingSoonToggleMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns the site's debug mode status
 * @summary settings debug status
 */
export const sitesSettingsDebug = (siteId, options) => {
    return axios.get(`/v1/sites/${siteId}/settings/debug`, options);
};
export const getSitesSettingsDebugQueryKey = (siteId) => {
    return [`/v1/sites/${siteId}/settings/debug`];
};
export const getSitesSettingsDebugQueryOptions = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesSettingsDebugQueryKey(siteId);
    const queryFn = ({ signal }) => sitesSettingsDebug(siteId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary settings debug status
 */
export function useSitesSettingsDebug(siteId, options) {
    const queryOptions = getSitesSettingsDebugQueryOptions(siteId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Enables or disables the output and display of site generated errors on the site
 * @summary settings debug toggle
 */
export const sitesSettingsDebugToggle = (siteId, sitesSettingsDebugToggleBody, options) => {
    return axios.post(`/v1/sites/${siteId}/settings/debug`, sitesSettingsDebugToggleBody, options);
};
export const getSitesSettingsDebugToggleMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return sitesSettingsDebugToggle(siteId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary settings debug toggle
*/
export const useSitesSettingsDebugToggle = (options) => {
    const mutationOptions = getSitesSettingsDebugToggleMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Updates the site's PHP version
 * @summary settings php version update
 */
export const sitesSettingsPhpVersionUpdate = (siteId, sitesSettingsPhpVersionUpdateBody, options) => {
    return axios.post(`/v1/sites/${siteId}/settings/php-version`, sitesSettingsPhpVersionUpdateBody, options);
};
export const getSitesSettingsPhpVersionUpdateMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return sitesSettingsPhpVersionUpdate(siteId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary settings php version update
*/
export const useSitesSettingsPhpVersionUpdate = (options) => {
    const mutationOptions = getSitesSettingsPhpVersionUpdateMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Gets the list of PHP versions available/installed
 * @summary settings php versions list
 */
export const sitesSettingsPhpVersions = (siteId, options) => {
    return axios.get(`/v1/sites/${siteId}/settings/php-versions`, options);
};
export const getSitesSettingsPhpVersionsQueryKey = (siteId) => {
    return [`/v1/sites/${siteId}/settings/php-versions`];
};
export const getSitesSettingsPhpVersionsQueryOptions = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesSettingsPhpVersionsQueryKey(siteId);
    const queryFn = ({ signal }) => sitesSettingsPhpVersions(siteId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary settings php versions list
 */
export function useSitesSettingsPhpVersions(siteId, options) {
    const queryOptions = getSitesSettingsPhpVersionsQueryOptions(siteId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * List ssh users
 * @deprecated
 * @summary site - ssh - list users
 */
export const sitesSshUserList = (siteId, options) => {
    return axios.get(`/v1/sites/${siteId}/ssh-users`, options);
};
export const getSitesSshUserListQueryKey = (siteId) => {
    return [`/v1/sites/${siteId}/ssh-users`];
};
export const getSitesSshUserListQueryOptions = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesSshUserListQueryKey(siteId);
    const queryFn = ({ signal }) => sitesSshUserList(siteId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @deprecated
 * @summary site - ssh - list users
 */
export function useSitesSshUserList(siteId, options) {
    const queryOptions = getSitesSshUserListQueryOptions(siteId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Create ssh user
 * @summary site - ssh - create user
 */
export const sitesSshUserCreate = (siteId, sitesSshUserCreateBody, options) => {
    return axios.post(`/v1/sites/${siteId}/ssh-users`, sitesSshUserCreateBody, options);
};
export const getSitesSshUserCreateMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return sitesSshUserCreate(siteId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary site - ssh - create user
*/
export const useSitesSshUserCreate = (options) => {
    const mutationOptions = getSitesSshUserCreateMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * delete ssh user
 * @summary site - ssh - delete user
 */
export const sitesSshUserDelete = (siteId, sitesSshUserDeleteBody, options) => {
    return axios.delete(`/v1/sites/${siteId}/ssh-users`, Object.assign({ data: sitesSshUserDeleteBody }, options));
};
export const getSitesSshUserDeleteMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return sitesSshUserDelete(siteId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary site - ssh - delete user
*/
export const useSitesSshUserDelete = (options) => {
    const mutationOptions = getSitesSshUserDeleteMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * update ssh user
 * @summary site - ssh - update user
 */
export const sitesSshUserUpdate = (siteId, sitesSshUserUpdateBody, options) => {
    return axios.put(`/v1/sites/${siteId}/ssh-users`, sitesSshUserUpdateBody, options);
};
export const getSitesSshUserUpdateMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return sitesSshUserUpdate(siteId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary site - ssh - update user
*/
export const useSitesSshUserUpdate = (options) => {
    const mutationOptions = getSitesSshUserUpdateMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns information about the site domain's SSL/TLS certificate
 * @summary Site domain SSL cert info
 */
export const sitesSsl = (siteId, options) => {
    return axios.get(`/v1/sites/${siteId}/ssl`, options);
};
export const getSitesSslQueryKey = (siteId) => {
    return [`/v1/sites/${siteId}/ssl`];
};
export const getSitesSslQueryOptions = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesSslQueryKey(siteId);
    const queryFn = ({ signal }) => sitesSsl(siteId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary Site domain SSL cert info
 */
export function useSitesSsl(siteId, options) {
    const queryOptions = getSitesSslQueryOptions(siteId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns an SSO token or login URL for the site (if supported).
 * @summary sso
 */
export const sitesSso = (siteId, params, options) => {
    return axios.get(`/v1/sites/${siteId}/sso`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getSitesSsoQueryKey = (siteId, params) => {
    return [`/v1/sites/${siteId}/sso`, ...(params ? [params] : [])];
};
export const getSitesSsoQueryOptions = (siteId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesSsoQueryKey(siteId, params);
    const queryFn = ({ signal }) => sitesSso(siteId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary sso
 */
export function useSitesSso(siteId, params, options) {
    const queryOptions = getSitesSsoQueryOptions(siteId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Promote a staging site
 * @summary Staging site promotion
 */
export const stagingSitePromote = (siteId, stagingSitePromoteBody, options) => {
    return axios.post(`/v1/sites/${siteId}/staging`, stagingSitePromoteBody, options);
};
export const getStagingSitePromoteMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return stagingSitePromote(siteId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Staging site promotion
*/
export const useStagingSitePromote = (options) => {
    const mutationOptions = getStagingSitePromoteMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * @summary site status
 */
export const siteStatus = (siteId, options) => {
    return axios.get(`/v1/sites/${siteId}/status`, options);
};
export const getSiteStatusQueryKey = (siteId) => {
    return [`/v1/sites/${siteId}/status`];
};
export const getSiteStatusQueryOptions = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSiteStatusQueryKey(siteId);
    const queryFn = ({ signal }) => siteStatus(siteId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary site status
 */
export function useSiteStatus(siteId, options) {
    const queryOptions = getSiteStatusQueryOptions(siteId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns a list of the site's users
 * @deprecated
 * @summary users
 */
export const siteUsers = (siteId, options) => {
    return axios.get(`/v1/sites/${siteId}/users`, options);
};
export const getSiteUsersQueryKey = (siteId) => {
    return [`/v1/sites/${siteId}/users`];
};
export const getSiteUsersQueryOptions = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSiteUsersQueryKey(siteId);
    const queryFn = ({ signal }) => siteUsers(siteId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @deprecated
 * @summary users
 */
export function useSiteUsers(siteId, options) {
    const queryOptions = getSiteUsersQueryOptions(siteId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns site version information.
 * @summary version
 */
export const sitesVersion = (siteId, options) => {
    return axios.get(`/v1/sites/${siteId}/version`, options);
};
export const getSitesVersionQueryKey = (siteId) => {
    return [`/v1/sites/${siteId}/version`];
};
export const getSitesVersionQueryOptions = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesVersionQueryKey(siteId);
    const queryFn = ({ signal }) => sitesVersion(siteId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary version
 */
export function useSitesVersion(siteId, options) {
    const queryOptions = getSitesVersionQueryOptions(siteId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Creates wpsolution license addon for site_id
 * @summary configure wpsolution license for site_id
 */
export const siteAddonWpsolution = (siteId, siteAddonWpsolutionBody, options) => {
    return axios.post(`/v1/sites/${siteId}/wpsolution`, siteAddonWpsolutionBody, options);
};
export const getSiteAddonWpsolutionMutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { siteId, data } = props !== null && props !== void 0 ? props : {};
        return siteAddonWpsolution(siteId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary configure wpsolution license for site_id
*/
export const useSiteAddonWpsolution = (options) => {
    const mutationOptions = getSiteAddonWpsolutionMutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Returns an oauth login URL that can be used to access Sitelock dashboard for a user.
 * @summary sso
 */
export const addonsSitelockSsoV2 = (addonId, params, options) => {
    return axios.get(`/v2/addons/sitelock/${addonId}/sso`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getAddonsSitelockSsoV2QueryKey = (addonId, params) => {
    return [`/v2/addons/sitelock/${addonId}/sso`, ...(params ? [params] : [])];
};
export const getAddonsSitelockSsoV2QueryOptions = (addonId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getAddonsSitelockSsoV2QueryKey(addonId, params);
    const queryFn = ({ signal }) => addonsSitelockSsoV2(addonId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(addonId) }, queryOptions);
};
/**
 * @summary sso
 */
export function useAddonsSitelockSsoV2(addonId, params, options) {
    const queryOptions = getAddonsSitelockSsoV2QueryOptions(addonId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Backup create
 * @deprecated
 * @summary Backup create
 */
export const backupCreateV2 = (addonId, backupCreateV2Body, options) => {
    return axios.post(`/v2/addons/${addonId}/backup/create`, backupCreateV2Body, options);
};
export const getBackupCreateV2MutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { addonId, data } = props !== null && props !== void 0 ? props : {};
        return backupCreateV2(addonId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @deprecated
* @summary Backup create
*/
export const useBackupCreateV2 = (options) => {
    const mutationOptions = getBackupCreateV2MutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Backup download
 * @summary Backup download
 */
export const backupDownloadV2 = (addonId, backupDownloadV2Body, options) => {
    return axios.post(`/v2/addons/${addonId}/backup/download`, backupDownloadV2Body, options);
};
export const getBackupDownloadV2MutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { addonId, data } = props !== null && props !== void 0 ? props : {};
        return backupDownloadV2(addonId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Backup download
*/
export const useBackupDownloadV2 = (options) => {
    const mutationOptions = getBackupDownloadV2MutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Backup list
 * @summary Backup list
 */
export const backupListV2 = (addonId, options) => {
    return axios.get(`/v2/addons/${addonId}/backup/list`, options);
};
export const getBackupListV2QueryKey = (addonId) => {
    return [`/v2/addons/${addonId}/backup/list`];
};
export const getBackupListV2QueryOptions = (addonId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getBackupListV2QueryKey(addonId);
    const queryFn = ({ signal }) => backupListV2(addonId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(addonId) }, queryOptions);
};
/**
 * @summary Backup list
 */
export function useBackupListV2(addonId, options) {
    const queryOptions = getBackupListV2QueryOptions(addonId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Backup restore
 * @summary Backup restore
 */
export const backupRestoreV2 = (addonId, backupRestoreV2Body, options) => {
    return axios.post(`/v2/addons/${addonId}/backup/restore`, backupRestoreV2Body, options);
};
export const getBackupRestoreV2MutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { addonId, data } = props !== null && props !== void 0 ? props : {};
        return backupRestoreV2(addonId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Backup restore
*/
export const useBackupRestoreV2 = (options) => {
    const mutationOptions = getBackupRestoreV2MutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Backup status
 * @summary Backup status
 */
export const backupStatusV2 = (addonId, params, options) => {
    return axios.get(`/v2/addons/${addonId}/backup/status`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getBackupStatusV2QueryKey = (addonId, params) => {
    return [`/v2/addons/${addonId}/backup/status`, ...(params ? [params] : [])];
};
export const getBackupStatusV2QueryOptions = (addonId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getBackupStatusV2QueryKey(addonId, params);
    const queryFn = ({ signal }) => backupStatusV2(addonId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(addonId) }, queryOptions);
};
/**
 * @summary Backup status
 */
export function useBackupStatusV2(addonId, params, options) {
    const queryOptions = getBackupStatusV2QueryOptions(addonId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * List all DB names
 * @summary Get list of database names
 */
export const dbListV2 = (hostingId, options) => {
    return axios.get(`/v2/hosting/${hostingId}/db`, options);
};
export const getDbListV2QueryKey = (hostingId) => {
    return [`/v2/hosting/${hostingId}/db`];
};
export const getDbListV2QueryOptions = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getDbListV2QueryKey(hostingId);
    const queryFn = ({ signal }) => dbListV2(hostingId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary Get list of database names
 */
export function useDbListV2(hostingId, options) {
    const queryOptions = getDbListV2QueryOptions(hostingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Unassign the domain associated with the hosting account
 * @summary Unassign the domain
 */
export const hostingDomainsUnassignV2 = (hostingId, hostingDomainsUnassignV2Body, options) => {
    return axios.post(`/v2/hosting/${hostingId}/domains/unassign`, hostingDomainsUnassignV2Body, options);
};
export const getHostingDomainsUnassignV2MutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return hostingDomainsUnassignV2(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Unassign the domain
*/
export const useHostingDomainsUnassignV2 = (options) => {
    const mutationOptions = getHostingDomainsUnassignV2MutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * List files under the given directory
 * @summary List files
 */
export const listFilesV2 = (hostingId, params, options) => {
    return axios.get(`/v2/hosting/${hostingId}/files`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getListFilesV2QueryKey = (hostingId, params) => {
    return [`/v2/hosting/${hostingId}/files`, ...(params ? [params] : [])];
};
export const getListFilesV2QueryOptions = (hostingId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getListFilesV2QueryKey(hostingId, params);
    const queryFn = ({ signal }) => listFilesV2(hostingId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary List files
 */
export function useListFilesV2(hostingId, params, options) {
    const queryOptions = getListFilesV2QueryOptions(hostingId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns the hosting server nameservers information
 * @summary hosting server nameservers info
 */
export const hostingNameserversV2 = (hostingId, options) => {
    return axios.get(`/v2/hosting/${hostingId}/nameservers`, options);
};
export const getHostingNameserversV2QueryKey = (hostingId) => {
    return [`/v2/hosting/${hostingId}/nameservers`];
};
export const getHostingNameserversV2QueryOptions = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHostingNameserversV2QueryKey(hostingId);
    const queryFn = ({ signal }) => hostingNameserversV2(hostingId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary hosting server nameservers info
 */
export function useHostingNameserversV2(hostingId, options) {
    const queryOptions = getHostingNameserversV2QueryOptions(hostingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns the list of site's redirects
 * @summary List redirects
 */
export const hostingRedirectsV2 = (hostingId, options) => {
    return axios.get(`/v2/hosting/${hostingId}/redirects`, options);
};
export const getHostingRedirectsV2QueryKey = (hostingId) => {
    return [`/v2/hosting/${hostingId}/redirects`];
};
export const getHostingRedirectsV2QueryOptions = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHostingRedirectsV2QueryKey(hostingId);
    const queryFn = ({ signal }) => hostingRedirectsV2(hostingId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary List redirects
 */
export function useHostingRedirectsV2(hostingId, options) {
    const queryOptions = getHostingRedirectsV2QueryOptions(hostingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns a list of sites.
 * @summary sites list v2
 */
export const hostingSitesV2 = (hostingId, params, options) => {
    return axios.get(`/v2/hosting/${hostingId}/sites`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getHostingSitesV2QueryKey = (hostingId, params) => {
    return [`/v2/hosting/${hostingId}/sites`, ...(params ? [params] : [])];
};
export const getHostingSitesV2QueryOptions = (hostingId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getHostingSitesV2QueryKey(hostingId, params);
    const queryFn = ({ signal }) => hostingSitesV2(hostingId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary sites list v2
 */
export function useHostingSitesV2(hostingId, params, options) {
    const queryOptions = getHostingSitesV2QueryOptions(hostingId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Add a site to the current hosting.
 * @summary sites add
 */
export const hostingSiteAddV2 = (hostingId, hostingSiteAddV2Body, options) => {
    return axios.post(`/v2/hosting/${hostingId}/sites`, hostingSiteAddV2Body, options);
};
export const getHostingSiteAddV2MutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return hostingSiteAddV2(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary sites add
*/
export const useHostingSiteAddV2 = (options) => {
    const mutationOptions = getHostingSiteAddV2MutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Import public/private ssh key
 * @deprecated
 * @summary Deprecated -Import ssh key
 */
export const sshKeyImportV2 = (hostingId, sshKeyImportV2Body, options) => {
    return axios.post(`/v2/hosting/${hostingId}/ssh/import`, sshKeyImportV2Body, options);
};
export const getSshKeyImportV2MutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return sshKeyImportV2(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @deprecated
* @summary Deprecated -Import ssh key
*/
export const useSshKeyImportV2 = (options) => {
    const mutationOptions = getSshKeyImportV2MutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * List all SSH keys on a server or account. Finds all keys in user's .ssh/ diretory.
 * @deprecated
 * @summary Deprecated - ssh keys list
 */
export const sshKeyListV2 = (hostingId, options) => {
    return axios.get(`/v2/hosting/${hostingId}/ssh/keys`, options);
};
export const getSshKeyListV2QueryKey = (hostingId) => {
    return [`/v2/hosting/${hostingId}/ssh/keys`];
};
export const getSshKeyListV2QueryOptions = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSshKeyListV2QueryKey(hostingId);
    const queryFn = ({ signal }) => sshKeyListV2(hostingId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @deprecated
 * @summary Deprecated - ssh keys list
 */
export function useSshKeyListV2(hostingId, options) {
    const queryOptions = getSshKeyListV2QueryOptions(hostingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Deletes an SSH key
 * @summary ssh key delete
 */
export const sshKeyV2 = (hostingId, sshKeyV2Body, options) => {
    return axios.delete(`/v2/hosting/${hostingId}/ssh/keys`, Object.assign({ data: sshKeyV2Body }, options));
};
export const getSshKeyV2MutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return sshKeyV2(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary ssh key delete
*/
export const useSshKeyV2 = (options) => {
    const mutationOptions = getSshKeyV2MutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Deprecated - use sites_list_v3 instead
 * @deprecated
 * @summary Site list for an account v2
 */
export const sitesListV2 = (options) => {
    return axios.get(`/v2/sites`, options);
};
export const getSitesListV2QueryKey = () => {
    return [`/v2/sites`];
};
export const getSitesListV2QueryOptions = (options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesListV2QueryKey();
    const queryFn = ({ signal }) => sitesListV2(Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn }, queryOptions);
};
/**
 * @deprecated
 * @summary Site list for an account v2
 */
export function useSitesListV2(options) {
    const queryOptions = getSitesListV2QueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns v2 site information. (compatible platforms: jarvis, hal)
 * @summary site info
 */
export const sitesInfoV2 = (siteId, options) => {
    return axios.get(`/v2/sites/${siteId}`, options);
};
export const getSitesInfoV2QueryKey = (siteId) => {
    return [`/v2/sites/${siteId}`];
};
export const getSitesInfoV2QueryOptions = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesInfoV2QueryKey(siteId);
    const queryFn = ({ signal }) => sitesInfoV2(siteId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary site info
 */
export function useSitesInfoV2(siteId, options) {
    const queryOptions = getSitesInfoV2QueryOptions(siteId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Provides the domains list associated with the site
 * @summary Domains list for the site
 */
export const sitesDomainsV2 = (siteId, params, options) => {
    return axios.get(`/v2/sites/${siteId}/domains`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getSitesDomainsV2QueryKey = (siteId, params) => {
    return [`/v2/sites/${siteId}/domains`, ...(params ? [params] : [])];
};
export const getSitesDomainsV2QueryOptions = (siteId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesDomainsV2QueryKey(siteId, params);
    const queryFn = ({ signal }) => sitesDomainsV2(siteId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary Domains list for the site
 */
export function useSitesDomainsV2(siteId, params, options) {
    const queryOptions = getSitesDomainsV2QueryOptions(siteId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns malware status of atomic site
 * @summary malware status of atomic site
 */
export const siteMalwareStatusV2 = (siteId, options) => {
    return axios.get(`/v2/sites/${siteId}/malware-status`, options);
};
export const getSiteMalwareStatusV2QueryKey = (siteId) => {
    return [`/v2/sites/${siteId}/malware-status`];
};
export const getSiteMalwareStatusV2QueryOptions = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSiteMalwareStatusV2QueryKey(siteId);
    const queryFn = ({ signal }) => siteMalwareStatusV2(siteId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary malware status of atomic site
 */
export function useSiteMalwareStatusV2(siteId, options) {
    const queryOptions = getSiteMalwareStatusV2QueryOptions(siteId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns the site's sitelock information.
 * @summary sitelock info
 */
export const sitesSecuritySitelockV2 = (siteId, params, options) => {
    return axios.get(`/v2/sites/${siteId}/security/sitelock`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getSitesSecuritySitelockV2QueryKey = (siteId, params) => {
    return [`/v2/sites/${siteId}/security/sitelock`, ...(params ? [params] : [])];
};
export const getSitesSecuritySitelockV2QueryOptions = (siteId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesSecuritySitelockV2QueryKey(siteId, params);
    const queryFn = ({ signal }) => sitesSecuritySitelockV2(siteId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary sitelock info
 */
export function useSitesSecuritySitelockV2(siteId, params, options) {
    const queryOptions = getSitesSecuritySitelockV2QueryOptions(siteId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * List ssh users V2
 * @summary site - ssh - list users v2
 */
export const sitesSshUserListV2 = (siteId, options) => {
    return axios.get(`/v2/sites/${siteId}/ssh-users`, options);
};
export const getSitesSshUserListV2QueryKey = (siteId) => {
    return [`/v2/sites/${siteId}/ssh-users`];
};
export const getSitesSshUserListV2QueryOptions = (siteId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesSshUserListV2QueryKey(siteId);
    const queryFn = ({ signal }) => sitesSshUserListV2(siteId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary site - ssh - list users v2
 */
export function useSitesSshUserListV2(siteId, options) {
    const queryOptions = getSitesSshUserListV2QueryOptions(siteId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns a list of the site's users with additional information like limit,offset, and total count
 * @summary users info
 */
export const siteUsersV2 = (siteId, params, options) => {
    return axios.get(`/v2/sites/${siteId}/users`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getSiteUsersV2QueryKey = (siteId, params) => {
    return [`/v2/sites/${siteId}/users`, ...(params ? [params] : [])];
};
export const getSiteUsersV2QueryOptions = (siteId, params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSiteUsersV2QueryKey(siteId, params);
    const queryFn = ({ signal }) => siteUsersV2(siteId, params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(siteId) }, queryOptions);
};
/**
 * @summary users info
 */
export function useSiteUsersV2(siteId, params, options) {
    const queryOptions = getSiteUsersV2QueryOptions(siteId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Backup create
 * @summary Backup create
 */
export const backupCreateV3 = (addonId, backupCreateV3Body, options) => {
    return axios.post(`/v3/addons/${addonId}/backup/create`, backupCreateV3Body, options);
};
export const getBackupCreateV3MutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { addonId, data } = props !== null && props !== void 0 ? props : {};
        return backupCreateV3(addonId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Backup create
*/
export const useBackupCreateV3 = (options) => {
    const mutationOptions = getBackupCreateV3MutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * Import public ssh key
 * @summary Import ssh key
 */
export const sshKeyImportV3 = (hostingId, sshKeyImportV3Body, options) => {
    return axios.post(`/v3/hosting/${hostingId}/ssh/import`, sshKeyImportV3Body, options);
};
export const getSshKeyImportV3MutationOptions = (options) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const mutationFn = (props) => {
        const { hostingId, data } = props !== null && props !== void 0 ? props : {};
        return sshKeyImportV3(hostingId, data, axiosOptions);
    };
    return Object.assign({ mutationFn }, mutationOptions);
};
/**
* @summary Import ssh key
*/
export const useSshKeyImportV3 = (options) => {
    const mutationOptions = getSshKeyImportV3MutationOptions(options);
    return useMutation(mutationOptions);
};
/**
 * List all SSH keys on a server or account. Finds all keys in user's .ssh/ directory.
 * @deprecated
 * @summary ssh keys list
 */
export const sshKeyListV3 = (hostingId, options) => {
    return axios.get(`/v3/hosting/${hostingId}/ssh/keys`, options);
};
export const getSshKeyListV3QueryKey = (hostingId) => {
    return [`/v3/hosting/${hostingId}/ssh/keys`];
};
export const getSshKeyListV3QueryOptions = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSshKeyListV3QueryKey(hostingId);
    const queryFn = ({ signal }) => sshKeyListV3(hostingId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @deprecated
 * @summary ssh keys list
 */
export function useSshKeyListV3(hostingId, options) {
    const queryOptions = getSshKeyListV3QueryOptions(hostingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns a list of sites. (Compatible platforms: jarvis, hal)
 * @summary Site list for an account v3
 */
export const sitesListV3 = (params, options) => {
    return axios.get(`/v3/sites`, Object.assign(Object.assign({}, options), { params: Object.assign(Object.assign({}, params), options === null || options === void 0 ? void 0 : options.params) }));
};
export const getSitesListV3QueryKey = (params) => {
    return [`/v3/sites`, ...(params ? [params] : [])];
};
export const getSitesListV3QueryOptions = (params, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSitesListV3QueryKey(params);
    const queryFn = ({ signal }) => sitesListV3(params, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn }, queryOptions);
};
/**
 * @summary Site list for an account v3
 */
export function useSitesListV3(params, options) {
    const queryOptions = getSitesListV3QueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * List all SSH keys on a server or account. Finds all keys in user's .ssh/ directory.
 * @summary ssh keys list
 */
export const sshKeyListV4 = (hostingId, options) => {
    return axios.get(`/v4/hosting/${hostingId}/ssh/keys`, options);
};
export const getSshKeyListV4QueryKey = (hostingId) => {
    return [`/v4/hosting/${hostingId}/ssh/keys`];
};
export const getSshKeyListV4QueryOptions = (hostingId, options) => {
    var _a;
    const { query: queryOptions, axios: axiosOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getSshKeyListV4QueryKey(hostingId);
    const queryFn = ({ signal }) => sshKeyListV4(hostingId, Object.assign({ signal }, axiosOptions));
    return Object.assign({ queryKey, queryFn, enabled: !!(hostingId) }, queryOptions);
};
/**
 * @summary ssh keys list
 */
export function useSshKeyListV4(hostingId, options) {
    const queryOptions = getSshKeyListV4QueryOptions(hostingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
